import React, { useState, useEffect, useRef } from "react";
import { Loader, Dimmer } from "semantic-ui-react";
import axios from "axios";
import { Mensaje, MensajeSiNo } from "../mensajes";
import { TableBody, TableRow, TableCell } from "@material-ui/core";
import {
  seleccionarCampo,
  formatMoneda,
  validaSoloNumero,
  validaMonto,
  cmbCedula,
  onCambioMoneda,
  onCambioUnidad,
  calcularTotales,
  validarCantidad,
  comboprecios,
  lpad,
} from "../../util/varios";
import moment from "moment";
import CatalogoProductoExistencia from "../../catalogos/catalogoProductoExistencia";
import CatalogoCliente from "../../catalogos/catalogoCliente";
import useTableScroll from "../useTableScroll";
import CatalogoPedido from "../../catalogos/catalogoPedido";
import { RegistrarPago } from "./modalRegistrarPago";
import { ModalSupervisor } from "./modalSupervisor";

const TablaPosVenta = () => {


  const op = require("../../../public/modulos/datos");
  const token = sessionStorage.getItem("jwtToken");
  const organizacion = JSON.parse(sessionStorage.getItem("riforganizacion"));
  const fechasistema = JSON.parse(sessionStorage.getItem("fechasistema"));
  const accbtnpedidos = JSON.parse(sessionStorage.getItem("accbtnpedidosc"));
  const idagente = JSON.parse(sessionStorage.getItem("idagente"));
  const tipopre = JSON.parse(sessionStorage.getItem("post"));

  const txtNumPedido = useRef();
  const txtFecha = useRef();
  const txtStatus = useRef();
  const txtId = useRef([]);
  const txtCantidad = useRef([]);
  const txtNunnota = useRef();
  const btnEditar = useRef();
  const txtIdnota = useRef();
  const txtIdproducto = useRef();
  const btnCancela = useRef();
  const btnAcepta = useRef();
  const btnProducto = useRef();
  const cmbRif = useRef();
  const txtRif = useRef();
  const txtFechaVence = useRef();
  const txtCredito = useRef();
  const txtNombreC = useRef();
  const txtNombreV = useRef();
  const txtSubTotal = useRef();
  const txtDescuento = useRef();
  const txtExentoTotal = useRef();
  const txtTotIva = useRef();
  const txtTotal = useRef();
  const txtTotalBs = useRef();
  const cmbMoneda = useRef();

  // Estados para Bluetooth e impresión
  const [bluetoothStatus, setBluetoothStatus] = useState({
    checked: false,
    available: false,
    message: 'Bluetooth no activado',
    support: false,
    granted: false,
    isDesktop: false,
    platform: '',
    browser: ''
  });

  const [printerStatus, setPrinterStatus] = useState({
    connected: false,
    device: null,
    server: null,
    name: '',
    scanning: false,
    printing: false,
    statusMessage: 'Conecte una impresora Bluetooth',
    scannedDevice: null,
    errorDetails: '',
    services: [],
    connectionAttempts: 0,
    printerType: null, // 'jingpu', 'mp80', 'mtp', 'unknown'
    characteristic: null,
    service: null
  });

  // BASE DE DATOS DE IMPRESORAS CON SUS CONFIGURACIONES
  const PRINTER_DATABASE = {
    'jingpu': {
      namePatterns: ['jingpu', 'jp', '58mm'],
      services: ['00001101-0000-1000-8000-00805f9b34fb'], // SPP
      characteristics: ['0000ff02-0000-1000-8000-00805f9b34fb'],
      baudRate: 9600,
      encoding: 'gbk',
      needsDelay: true,
      chunkSize: 20
    },
    'mp80': {
      namePatterns: ['mp80', 'mp-80', 'mp80-04'],
      services: [
        '00001101-0000-1000-8000-00805f9b34fb', // SPP
        '49535343-fe7d-4ae5-8fa9-9fafd205e455'  // Servicio chino
      ],
      characteristics: [
        '0000ff02-0000-1000-8000-00805f9b34fb',
        '0000ff01-0000-1000-8000-00805f9b34fb'
      ],
      baudRate: 115200,
      encoding: 'utf-8',
      needsDelay: false,
      chunkSize: 40
    },
    'mtp': {
      namePatterns: ['mtp', 'mtp-3', 'mtp3'],
      services: [
        '00001101-0000-1000-8000-00805f9b34fb', // SPP
        '000018f0-0000-1000-8000-00805f9b34fb', // Servicio estándar
        'e7810a71-73ae-499d-8c15-faa9aef0c3f2'  // Servicio específico
      ],
      characteristics: [
        '00002af1-0000-1000-8000-00805f9b34fb',
        'bef8d6c9-9c21-4c9e-b632-bd58c1009f9f',
        'e7810a71-73ae-499d-8c15-faa9aef0c3f2'
      ],
      baudRate: 9600,
      encoding: 'utf-8',
      needsDelay: true,
      chunkSize: 10,
      requiresPairing: true
    }
  };

  // Servicios universales para probar
  const UNIVERSAL_SERVICES = [
    '00001101-0000-1000-8000-00805f9b34fb', // SPP - MÁS IMPORTANTE
    '49535343-fe7d-4ae5-8fa9-9fafd205e455', // Servicio chino común
    '000018f0-0000-1000-8000-00805f9b34fb', // Servicio estándar
    'e7810a71-73ae-499d-8c15-faa9aef0c3f2', // Servicio específico
    '0000ff00-0000-1000-8000-00805f9b34fb', // Otro común
    '0000ae00-0000-1000-8000-00805f9b34fb'  // Otro común
  ];

  const UNIVERSAL_CHARACTERISTICS = [
    '0000ff02-0000-1000-8000-00805f9b34fb', // Característica común 1
    '0000ff01-0000-1000-8000-00805f9b34fb', // Característica común 2
    '00002af1-0000-1000-8000-00805f9b34fb', // Característica estándar
    'bef8d6c9-9c21-4c9e-b632-bd58c1009f9f', // Característica específica
    'e7810a71-73ae-499d-8c15-faa9aef0c3f2', // Característica específica
    '0000ae01-0000-1000-8000-00805f9b34fb'  // Otra característica
  ];


  const checkBluetoothSupport = () => {
    const isSupported = 'bluetooth' in navigator;
    setBluetoothStatus(prev => ({
      ...prev,
      support: isSupported,
      message: isSupported ? 'Web Bluetooth disponible' : 'Web Bluetooth no soportado'
    }));
  };

  const handleBluetoothChange = async (e) => {
    const isChecked = e.target.checked;

    if (isChecked) {
      await requestBluetoothPermission();
    } else {
      /* if (printerStatus.connected) {
        disconnectPrinter();
      } */

      setBluetoothStatus(prev => ({
        ...prev,
        checked: false,
        granted: false,
        message: 'Bluetooth desactivado'
      }));

      setPrinterStatus({
        connected: false,
        device: null,
        server: null,
        name: '',
        scanning: false,
        printing: false,
        statusMessage: 'Bluetooth desactivado',
        scannedDevice: null,
        errorDetails: '',
        services: [],
        connectionAttempts: 0,
        printerType: null,
        characteristic: null,
        service: null
      });
    }
  };

  const requestBluetoothPermission = async () => {
    if (!bluetoothStatus.support) {
      setMensaje({
        mostrar: true,
        titulo: "Web Bluetooth no soportado",
        texto: "Tu navegador no soporta Web Bluetooth",
        icono: "error"
      });
      setBluetoothStatus(prev => ({ ...prev, checked: false }));
      return;
    }

    try {
      setBluetoothStatus(prev => ({
        ...prev,
        message: 'Verificando Bluetooth...',
        checked: true
      }));



      let isAvailable = false;
      try {
        isAvailable = await navigator.bluetooth.getAvailability();
      } catch (error) {
        console.log('Error verificando disponibilidad:', error);
        isAvailable = true; // Asumir disponible
      }

      setBluetoothStatus(prev => ({
        ...prev,
        available: isAvailable,
        granted: true,
        message: isAvailable ? '✅ Bluetooth disponible' : '❌ Bluetooth no disponible'
      }));

    } catch (error) {
      console.error('Error al solicitar permiso:', error);
      setBluetoothStatus(prev => ({
        ...prev,
        available: false,
        granted: false,
        checked: false,
        message: `Error: ${error.message}`
      }));
    }
  };

  // Detectar tipo de impresora por nombre
  const detectPrinterType = (deviceName) => {
    if (!deviceName) return 'unknown';

    const nameLower = deviceName.toLowerCase();

    for (const [type, config] of Object.entries(PRINTER_DATABASE)) {
      for (const pattern of config.namePatterns) {
        if (nameLower.includes(pattern.toLowerCase())) {
          console.log(`🔍 Impresora detectada: ${type} (${deviceName})`);
          return type;
        }
      }
    }

    // Si no coincide con ningún patrón conocido
    if (nameLower.includes('58') || nameLower.includes('58mm')) {
      return 'jingpu';
    } else if (nameLower.includes('80') || nameLower.includes('80mm')) {
      return 'mp80';
    } else if (nameLower.includes('mtp')) {
      return 'mtp';
    }

    return 'unknown';
  };

  const scanForBluetoothDevices = async () => {
    if (!bluetoothStatus.checked) {
      setMensaje({
        mostrar: true,
        titulo: "Bluetooth requerido",
        texto: "Active primero el Bluetooth",
        icono: "informacion"
      });
      return;
    }

    setPrinterStatus(prev => ({
      ...prev,
      scanning: true,
      statusMessage: 'Buscando impresoras...',
      errorDetails: ''
    }));

    try {
      console.log('🔍 Iniciando búsqueda universal...');

      const device = await navigator.bluetooth.requestDevice({
        acceptAllDevices: true,
        optionalServices: UNIVERSAL_SERVICES
      });

      console.log('✅ Dispositivo seleccionado:', device.name);

      // Detectar tipo de impresora
      const printerType = detectPrinterType(device.name);

      setPrinterStatus(prev => ({
        ...prev,
        scannedDevice: device,
        printerType: printerType,
        statusMessage: `✅ ${device.name} (${printerType})`
      }));

      device.addEventListener('gattserverdisconnected', () => {
        console.log('⚠️ Dispositivo desconectado.');
        handleAutoReconnect();
      });

      // Mostrar mensaje específico según tipo
      let printerInfo = '';
      if (printerType === 'jingpu') {
        printerInfo = 'Impresora Jingpu 58mm detectada. Esta impresora generalmente funciona bien.';
      } else if (printerType === 'mp80') {
        printerInfo = 'Impresora MP80-04 detectada. Puede requerir configuración especial.';
      } else if (printerType === 'mtp') {
        printerInfo = 'Impresora MTP-3 detectada. En PC, asegúrese de emparejarla primero en la configuración del sistema.';
      } else {
        printerInfo = 'Impresora no identificada. Se intentará conexión universal.';
      }

      setMensaje({
        mostrar: true,
        titulo: `Impresora ${device.name} detectada`,
        texto: printerInfo,
        icono: "informacion"
      });

    } catch (error) {
      console.error('❌ Error en búsqueda:', error);

      setPrinterStatus(prev => ({
        ...prev,
        statusMessage: '❌ Error de búsqueda',
        errorDetails: error.toString()
      }));

      setMensaje({
        mostrar: true,
        titulo: "Error de búsqueda",
        texto: error.message,
        icono: "error"
      });
    } finally {
      setPrinterStatus(prev => ({ ...prev, scanning: false }));
    }
  };

  // CONEXIÓN UNIVERSAL MEJORADA
  const connectToPrinter = async () => {
    if (!printerStatus.scannedDevice) {
      setMensaje({
        mostrar: true,
        titulo: "Primero busque",
        texto: "Busque un dispositivo Bluetooth primero",
        icono: "informacion"
      });
      return;
    }

    const device = printerStatus.scannedDevice;
    const printerType = printerStatus.printerType || 'unknown';

    setPrinterStatus(prev => ({
      ...prev,
      scanning: true,
      statusMessage: `Conectando a ${device.name}...`,
      errorDetails: ''
    }));

    try {
      console.log(`🔗 Conectando a ${device.name} (Tipo: ${printerType})`);

      if (!device.gatt) {
        throw new Error('Dispositivo no compatible con Bluetooth Low Energy');
      }

      // Configurar desconexión
      device.addEventListener('gattserverdisconnected', () => {
        console.log('⚠️ Dispositivo detectó desconexión.');

        // Llamamos a la función de reconexión automática
        handleAutoReconnect();
      });

      // Conexión con timeout
      let server;
      try {
        server = await device.gatt.connect();
        console.log('✅ Conexión GATT exitosa');
      } catch (error) {
        console.error('❌ Error en conexión GATT:', error);

        // Para MTP en PC, puede necesitar emparejamiento
        if (printerType === 'mtp' && bluetoothStatus.isDesktop) {
          throw new Error('MTP-3 necesita emparejamiento previo en Configuración > Bluetooth');
        }
        throw error;
      }

      // BUSCAR SERVICIO Y CARACTERÍSTICA UNIVERSAL
      let serviceFound = null;
      let characteristicFound = null;

      console.log('🔍 Buscando servicio y característica...');

      // Estrategia 1: Usar configuración específica del tipo de impresora
      if (printerType !== 'unknown' && PRINTER_DATABASE[printerType]) {
        const config = PRINTER_DATABASE[printerType];
        console.log(`🔧 Probando configuración específica para ${printerType}`);

        for (const serviceUUID of config.services) {
          try {
            const service = await server.getPrimaryService(serviceUUID);
            console.log(`✅ Servicio específico encontrado: ${serviceUUID}`);
            serviceFound = service;

            // Buscar característica específica
            for (const charUUID of config.characteristics) {
              try {
                const characteristic = await service.getCharacteristic(charUUID);
                if (characteristic.properties.write || characteristic.properties.writeWithoutResponse) {
                  console.log(`✅ Característica específica encontrada: ${charUUID}`);
                  characteristicFound = characteristic;
                  break;
                }
              } catch (charError) {
                console.log(`❌ Característica ${charUUID} no encontrada`);
              }
            }

            if (characteristicFound) break;
          } catch (serviceError) {
            console.log(`❌ Servicio ${serviceUUID} no encontrado`);
          }
        }
      }

      // Estrategia 2: Búsqueda universal
      if (!serviceFound || !characteristicFound) {
        console.log('🔍 Realizando búsqueda universal...');

        // Obtener todos los servicios
        const services = await server.getPrimaryServices();
        console.log(`📱 ${services.length} servicios disponibles`);

        for (const service of services) {
          try {
            const characteristics = await service.getCharacteristics();
            console.log(`🔍 Servicio ${service.uuid}: ${characteristics.length} características`);

            for (const char of characteristics) {
              console.log(`   ${char.uuid} - Write: ${char.properties.write}, WriteWithoutResponse: ${char.properties.writeWithoutResponse}`);

              if (char.properties.writeWithoutResponse) {
                console.log(`✅ Característica con writeWithoutResponse encontrada: ${char.uuid}`);
                serviceFound = service;
                characteristicFound = char;
                break;
              }

              if (char.properties.write) {
                console.log(`✅ Característica con write encontrada: ${char.uuid}`);
                serviceFound = service;
                characteristicFound = char;
                break;
              }
            }

            if (characteristicFound) break;
          } catch (error) {
            console.log(`⚠️ Error en servicio ${service.uuid}:`, error.message);
          }
        }
      }

      if (!serviceFound || !characteristicFound) {
        throw new Error('No se encontró servicio o característica de escritura');
      }

      // Estrategia 3: Usar cualquier característica que tenga write
      if (!characteristicFound) {
        console.log('⚠️ Usando cualquier característica con capacidad de escritura...');

        const services = await server.getPrimaryServices();
        for (const service of services) {
          try {
            const characteristics = await service.getCharacteristics();
            for (const char of characteristics) {
              if (char.properties.write) {
                serviceFound = service;
                characteristicFound = char;
                console.log(`⚠️ Característica de escritura encontrada: ${char.uuid}`);
                break;
              }
            }
            if (characteristicFound) break;
          } catch (error) {
            // Continuar con el siguiente servicio
          }
        }
      }

      if (!characteristicFound) {
        throw new Error('No se encontró ninguna característica con capacidad de escritura');
      }

      // Probar la característica con un comando simple
      console.log('🧪 Probando característica...');
      try {
        // Comando de inicialización ESC @
        const testCommand = new Uint8Array([0x1B, 0x40]);

        if (characteristicFound.properties.writeWithoutResponse) {
          await characteristicFound.writeValueWithoutResponse(testCommand);
          console.log('✅ Característica probada con writeWithoutResponse');
        } else if (characteristicFound.properties.write) {
          await characteristicFound.writeValue(testCommand);
          console.log('✅ Característica probada con write');
        }
      } catch (testError) {
        console.log('⚠️ Error probando característica:', testError.message);
        // Continuar aunque falle la prueba
      }

      // Actualizar estado
      setPrinterStatus(prev => ({
        ...prev,
        connected: true,
        device: device,
        server: server,
        name: device.name,
        service: serviceFound,
        characteristic: characteristicFound,
        statusMessage: `✅ Conectado a ${device.name}`,
        errorDetails: ''
      }));

      setMensaje({
        mostrar: true,
        titulo: "¡Conexión exitosa!",
        texto: `Conectado a ${device.name}. Servicio: ${serviceFound.uuid}\nCaracterística: ${characteristicFound.uuid}`,
        icono: "exito"
      });

    } catch (error) {
      console.error('❌ ERROR DE CONEXIÓN:', error);

      let solution = '';
      if (printerType === 'mtp') {
        solution = '\n\nPara MTP-3 en PC:\n1. Empareje en Configuración > Bluetooth\n2. Reinicie impresora\n3. Intente nuevamente';
      } else if (printerType === 'mp80') {
        solution = '\n\nPara MP80-04:\n1. Asegúrese de usar el servicio correcto\n2. Pruebe con diferentes modos de impresión';
      }

      setPrinterStatus(prev => ({
        ...prev,
        statusMessage: `❌ Error de conexión`,
        errorDetails: `${error.toString()}${solution}`,
        scannedDevice: null
      }));

      setMensaje({
        mostrar: true,
        titulo: "Error de conexión",
        texto: `No se pudo conectar a ${device.name}: ${error.message}${solution}`,
        icono: "error"
      });
    } finally {
      setPrinterStatus(prev => ({ ...prev, scanning: false }));
    }
  };

  // NUEVA FUNCIÓN: Reconexión Automática
  const handleAutoReconnect = async () => {
    const device = printerStatus.scannedDevice;
    const printerType = printerStatus.printerType || 'unknown';

    if (!device) return;

    // Evitar intentos múltiples simultáneos
    if (printerStatus.scanning || printerStatus.connected) return;

    console.log('⚠️ Impresora desconectada. Iniciando reconexión automática...');

    setPrinterStatus(prev => ({
      ...prev,
      scanning: true, // Usamos scanning para indicar que estamos ocupados
      statusMessage: '⚠️ Reconectando...',
      connected: false
    }));

    try {
      // 1. Conectar nuevamente
      const server = await device.gatt.connect();
      console.log('✅ GATT Reconectado');

      // 2. Buscar servicios y características (Lógica similar a connectToPrinter)
      let serviceFound = null;
      let characteristicFound = null;

      // Estrategia: Intentar usar la configuración conocida primero
      if (printerType !== 'unknown' && PRINTER_DATABASE[printerType]) {
        const config = PRINTER_DATABASE[printerType];
        for (const serviceUUID of config.services) {
          try {
            const service = await server.getPrimaryService(serviceUUID);
            serviceFound = service;
            for (const charUUID of config.characteristics) {
              try {
                const characteristic = await service.getCharacteristic(charUUID);
                if (characteristic.properties.write || characteristic.properties.writeWithoutResponse) {
                  characteristicFound = characteristic;
                  break;
                }
              } catch (e) { }
            }
            if (characteristicFound) break;
          } catch (e) { }
        }
      }

      // Búsqueda universal si falló la específica
      if (!serviceFound || !characteristicFound) {
        const services = await server.getPrimaryServices();
        for (const service of services) {
          try {
            const characteristics = await service.getCharacteristics();
            for (const char of characteristics) {
              if (char.properties.writeWithoutResponse || char.properties.write) {
                serviceFound = service;
                characteristicFound = char;
                break;
              }
            }
            if (characteristicFound) break;
          } catch (e) { }
        }
      }

      if (characteristicFound) {
        console.log('✅ Reconexión exitosa. Característica recuperada.');
        setPrinterStatus(prev => ({
          ...prev,
          connected: true,
          server: server,
          service: serviceFound,
          characteristic: characteristicFound,
          scanning: false,
          statusMessage: '✅ Reconectado'
        }));
      } else {
        throw new Error('No se pudo encontrar la característica al reconectar');
      }

    } catch (error) {
      console.error('❌ Error en reconexión automática:', error);
      setPrinterStatus(prev => ({
        ...prev,
        connected: false,
        scanning: false,
        statusMessage: '❌ Desconectado. Toque conectar manualmente.'
      }));
    }
  };

    const generateTicketWithTable = async (idFactura) => {
    console.log('\n🎫 Generando RECIBO (80mm) - Sin Negrita en cabeceras ID:', idFactura);
    try {
      // --- 1. CONFIGURACIÓN COMANDOS ESC/POS ---
      const ESC = '\x1B';
      const GS = '\x1D';
      const LF = '\n';
      
      // Ancho de papel en caracteres (80mm = aprox 64 caracteres)
      const PAPER_WIDTH = 64; 

      const cmd = {
        init: ESC + '@',
        center: ESC + 'a' + '\x01',
        left: ESC + 'a' + '\x00',
        boldOn: ESC + 'E' + '\x01',
        boldOff: ESC + 'E' + '\x00',
        doubleSize: ESC + '!' + '\x11', 
        normalSize: ESC + '!' + '\x00',
        cut: GS + 'V' + '\x00'
      };

      // --- 2. UTILIDADES (Dentro de la función) ---
      
      const formatoMoneda = (val) => {
        return parseFloat(val || 0).toFixed(2).replace('.', ',');
      };

      const crearLineaDoble = (txt1, txt2, ancho) => {
        const espacio = ancho - txt1.length - txt2.length;
        return txt1 + ' '.repeat(Math.max(0, espacio)) + txt2 + LF;
      };

      const crearLineaCuatroColumnas = (col1, col2, col3, col4, ancho) => {
        // Anchos para 80mm
        const wCant = 8;
        const wPrec = 14;
        const wTot = 14;
        const separadores = 3; 
        
        const maxDesc = ancho - wCant - wPrec - wTot - separadores;
        
        let desc = col1;
        if (desc.length > maxDesc) desc = desc.substring(0, maxDesc - 3) + '...';

        const c1 = desc.padEnd(maxDesc, ' ');
        const c2 = col2.padStart(wCant, ' ');
        const c3 = col3.padStart(wPrec, ' ');
        const c4 = col4.padStart(wTot, ' ');

        return `${c1} ${c2} ${c3} ${c4}${LF}`;
      };

      // --- 3. PETICIÓN API ---
      let endpoint = `${op.conexion}/api/ticket/selectfactura?idfactura=${idFactura}`;
      setActivate(true);

      const response = await axios.get(endpoint, { headers: { 'x-access-token': `${token}` } });

      if (response.status !== 200 || !response.data) throw new Error('Error API');

      const { factura, pagosDetalles, notaentrega } = response.data;

      if (!factura || factura.length === 0) throw new Error('Factura no encontrada');

      const facturaData = factura[0];
      const pagosData = pagosDetalles || [];

      // --- 4. PREPARAR DATOS ---
      
      const nombreorg = (facturaData.nombreorganizacionc || organizacion.nombre || 'MI EMPRESA').trim();
      const riforg = facturaData.riforganizacionc || organizacion.rif || '';

      const numNota = facturaData.numfacturac || '';
      const clienteRif = facturaData.rifclientec || '';
      const clienteNombre = facturaData.clientec || 'CONSUMIDOR FINAL';
      const clienteDireccion = facturaData.direccionclient || 'S/N';
      
      const fechaMoment = facturaData.txtfecha ? moment(facturaData.txtfecha) : moment();
      const fechaTxt = fechaMoment.format('DD/MM/YYYY');
      const horaTxt = fechaMoment.format('HH:mm:ss');

      const records = factura.map(item => ({
        nombre: item.nombreproducto || '',
        cantidad: parseFloat(item.cantidadn) || 0,
        punitario: parseFloat(item.precioconiva) || 0,
        unidad: item.unidadmedida || '' 
      }));

      const totalMonto = (notaentrega && notaentrega[0]) ? parseFloat(notaentrega[0].totalmonto) : 0;
      const tasa = parseFloat(facturaData.tasa) || 1;
      const totalBs = totalMonto * tasa;


      // --- 5. CONSTRUCCIÓN DEL TICKET ---
      let ticket = '';

      // 1. Inicializar
      ticket += cmd.init;

      // 2. Encabezado
      ticket += cmd.center;
      ticket += nombreorg + LF; 
      ticket += riforg + LF;     
      
      ticket += cmd.doubleSize;  
      ticket += 'RECIBO';
      ticket += cmd.normalSize;  
      ticket += LF;

      // 3. Información Venta
      ticket += cmd.left;
      ticket += crearLineaDoble(`NRO: ${numNota}`, `Fecha: ${fechaTxt}`, PAPER_WIDTH);
      ticket += crearLineaDoble(`RIF: ${clienteRif}`, `Hora: ${horaTxt}`, PAPER_WIDTH);
      
      ticket += `NOMBRE: ${clienteNombre.substring(0, 40)}` + LF; 
      ticket += `DIRECCIÓN: ${clienteDireccion.substring(0, 40)}` + LF;
      
      if (facturaData.txtmesonero) {
         ticket += `VENDEDOR: ${facturaData.txtmesonero}` + LF;
      }

      // 4. TABLA PRODUCTOS
      ticket += 'DETALLE PRODUCTOS:' + LF;
      ticket += '-'.repeat(PAPER_WIDTH) + LF;
      
      // --- TITULOS DE LA TABLA ---
      // NOTA: Se eliminó cmd.boldOn y cmd.boldOff porque la negrita ensancha las letras
      // y desalinea las columnas en impresoras térmicas.
      ticket += crearLineaCuatroColumnas('DESCRIPCION', 'CANT.', 'P-UNIT.', 'TOTAL', PAPER_WIDTH);
      ticket += '-'.repeat(PAPER_WIDTH) + LF;

      // Items
      records.forEach((item) => {
        const simboloUnidad = item.unidad ? item.unidad.charAt(0).toUpperCase() : 'U';
        const totalItem = item.cantidad * item.punitario;
        
        ticket += crearLineaCuatroColumnas(
          item.nombre,
          `${formatoMoneda(item.cantidad)} ${simboloUnidad}`,
          formatoMoneda(item.punitario),
          formatoMoneda(totalItem),
          PAPER_WIDTH
        );
      });

      // 5. Totales
      ticket += '='.repeat(PAPER_WIDTH) + LF;
      ticket += crearLineaDoble(
        `CANTIDAD ITEMS: ${records.length}`,
        `TOTAL $: ${formatoMoneda(totalMonto)}`,
        PAPER_WIDTH
      );

      if (tasa && tasa !== 1) {
         ticket += crearLineaDoble(
          '',
          `TOTAL Bs: ${formatoMoneda(totalBs)}`,
          PAPER_WIDTH
        );
      }

      // 6. Formas de Pago
      if (pagosData && pagosData.length > 0) {
        ticket += LF;
        ticket += '-'.repeat(PAPER_WIDTH) + LF;
        ticket += 'FORMA DE PAGO:' + LF;
        pagosData.forEach((pago) => {
           const montoPago = formatoMoneda(pago.monto);
           const nomPago = (pago.tipopago || 'EFECTIVO').substring(0, 25); 
           ticket += crearLineaDoble(nomPago, montoPago, PAPER_WIDTH);
        });
      }

      // 7. Footer
      ticket += LF; 

      // Texto Legal
      ticket += cmd.center;
      ticket += '========== SIN DERECHO A CRÉDITO FISCAL ==========' + LF;
      ticket += LF + LF + LF; 

      // 8. Cortar Papel
      ticket += cmd.cut;

      setActivate(false);
      return ticket;

    } catch (error) {
      setActivate(false);
      console.error('Error generando ticket:', error);
      throw error; 
    }
  };

  // USO:
  // generateTicketWithTable(1694).then(ticket => {
  //     // Usar el ticket para imprimir
  // }).catch(error => {
  //     console.error('Error:', error);
  // });

  // Función para probar diferentes formatos
  const printTestFormat = async (formatType = 'table') => {
    if (!printerStatus.connected) {
      setMensaje({
        mostrar: true,
        titulo: "No conectado",
        texto: "Conecte una impresora Bluetooth primero",
        icono: "informacion"
      });
      return;
    }

    setPrinterStatus(prev => ({
      ...prev,
      printing: true,
      statusMessage: `Imprimiendo formato ${formatType}...`
    }));

    try {
      let ticketContent = '';

      /*   switch (formatType) {
          case 'table':
            // AGREGAR AWAIT AQUÍ
            ticketContent = await generateTicketWithTable(1695);
            break;
          default:
            ticketContent = await generateTicketWithTable(1695);
        }
   */
      // Verificar que tenemos contenido para imprimir
      if (!ticketContent || ticketContent.trim() === '') {
        throw new Error('El ticket está vacío');
      }

      const encoder = new TextEncoder();
      const data = encoder.encode(ticketContent);
      const characteristic = printerStatus.characteristic;

      if (!characteristic) {
        throw new Error('No hay característica disponible para escritura');
      }

      // Enviar en chunks pequeños
      const chunkSize = printerStatus.printerType === 'mp80' ? 40 :
        printerStatus.printerType === 'jingpu' ? 20 : 10;

      console.log(`📤 Enviando ${data.length} bytes en chunks de ${chunkSize}...`);

      for (let i = 0; i < data.length; i += chunkSize) {
        const chunk = data.slice(i, i + chunkSize);

        try {
          if (characteristic.properties.writeWithoutResponse) {
            await characteristic.writeValueWithoutResponse(chunk);
            console.log(`📦 Chunk ${i}/${data.length} enviado (writeWithoutResponse)`);
          } else if (characteristic.properties.write) {
            await characteristic.writeValue(chunk);
            console.log(`📦 Chunk ${i}/${data.length} enviado (write)`);
          } else {
            throw new Error('La característica no tiene capacidad de escritura');
          }
        } catch (chunkError) {
          console.error(`❌ Error enviando chunk ${i}:`, chunkError);
          throw chunkError;
        }

        // Pequeña pausa entre chunks para no saturar
        if (i + chunkSize < data.length) {
          await new Promise(resolve => setTimeout(resolve, 5));
        }
      }

      console.log('✅ Ticket enviado completamente');

      setPrinterStatus(prev => ({
        ...prev,
        statusMessage: `✅ Formato ${formatType} impreso`,
        printing: false
      }));

      setMensaje({
        mostrar: true,
        titulo: "Impresión exitosa",
        texto: `Ticket enviado a la impresora ${printerStatus.name}`,
        icono: "exito"
      });

    } catch (error) {
      console.error('❌ Error en impresión:', error);
      setPrinterStatus(prev => ({
        ...prev,
        statusMessage: `❌ Error: ${error.message}`,
        printing: false
      }));

      setMensaje({
        mostrar: true,
        titulo: "Error de impresión",
        texto: error.message || 'Error desconocido al imprimir',
        icono: "error"
      });
    }
  };

  const disconnectPrinter = () => {
    if (printerStatus.device && printerStatus.device.gatt && printerStatus.device.gatt.connected) {
      try {
        printerStatus.device.gatt.disconnect();
      } catch (error) {
        console.log('Error al desconectar:', error);
      }
    }

    setPrinterStatus(prev => ({
      ...prev,
      connected: false,
      device: null,
      server: null,
      name: '',
      statusMessage: 'Desconectado',
      scannedDevice: null,
      errorDetails: '',
      services: [],
      printerType: null,
      characteristic: null,
      service: null
    }));

    setMensaje({
      mostrar: true,
      titulo: "Desconectado",
      texto: "Impresora desconectada",
      icono: "informacion"
    });
  };

  // Detectar plataforma
  useEffect(() => {

    checkBluetoothSupport();
  }, []);

  useEffect(() => {

    sessionStorage.setItem(
      "bluetooth",
      JSON.stringify(bluetoothStatus.checked)
    );


  }, [bluetoothStatus]);

  const [visibl, setVisibl] = useState(0);
  const [body, setBody] = useState(null);
  const [body2, setBody2] = useState(null);
  const [notaen, setNotaen] = useState([]);
  const [notaedeta, setNotaedeta] = useState([]);
  const [operacion, setOperacion] = useState(1);
  const [habilitado, setHabilitado] = useState(false);
  const [idpedi, setIdpedi] = useState(0);
  const [habilitadoBot, setHabilitadoBot] = useState(true);
  const [habilitadoCli, setHabilitadoCli] = useState(false);
  const [habilitadoProductos, setHabilitadoProductos] = useState(true);
  const [actimprime, setActimprime] = useState(0);
  const [indexs, setIndexs] = useState(null);
  const [mostrar, setMostrar] = useState(false);
  const [mostrar1, setMostrar1] = useState(false);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [pedido, setPedido] = useState({
    idpedido: "0",
    numpedido: "000000",
    cedularif: "",
    descripcion: "PEDIDO DE PRODUCTO",
    totalmonto: 0.0,
    totaliva: 0.0,
    totaldescuento: 0.0,
    totalexento: 0.0,
    totalsujeto: 0.0,
    idcliente: "",
    idvendedor: "",
    fecha: moment(fechasistema).format("YYYY-MM-DD"),
    status: 0,
    idalmacen: "",
    idmoneda: "",
    idoperacioninventario: "",
  });
  const [cliente, setCliente] = useState({
    idcliente: "",
    tiporif: "J",
    rif: "",
    nombre: "",
  });
  const [vendedor, setVendedor] = useState({
    idvendedor: "",
    tiporif: "J",
    rif: "",
    nombre: "",
    idalmacen: "",
  });
  const [tipoAgente, setTipoAgente] = useState("");
  const [numnotaentrega, setNumnotaentrega] = useState("");
  const [numnotaentregae, setNumnotaentregae] = useState(0);
  const [habilitarMoneda, setHabilitarMoneda] = useState(false);
  const [catalogoCliente, setCatalogoCliente] = useState(false);
  const [catalogoPedido, setCatalogoPedido] = useState(false);
  const [activate, setActivate] = useState(false);
  const [mostratsup, setMostrarsup] = useState(false);
  const [indice, setIndice] = useState(null);
  const [records, setRecords] = useState([]);
  const [listaProductos, setListaProductos] = useState([]);
  const [todosProductos, setTodosProductos] = useState([]);
  const [tituloHeader, setTituloHeader] = useState("Gestionar Venta.");
  const [combomoneda, setComboMoneda] = useState([]);
  const [opeinvc, setOpeinvc] = useState([]);
  const [opeinvdetc, setOpeinvdetc] = useState([]);
  const [moneda, setMoneda] = useState({
    idmoneda: "1",
    descripcion: "BOLIVARES",
    simbolo: "Bs",
    predeterminada: true,
    subpredeterminada: false,
    valormoneda: 1.0,
  });
  const [monedaSub, setMonedaSub] = useState({
    idmoneda: "4",
    descripcion: "DOLAR",
    simbolo: "$",
    predeterminada: false,
    subpredeterminada: true,
    valormoneda: 1.0,
  });
  const [monedaCambio, setMonedaCambio] = useState({
    idmoneda: "4",
    descripcion: "DOLAR",
    simbolo: "$",
    predeterminada: false,
    subpredeterminada: true,
    valormoneda: 1.0,
  });
  const [totales, setTotales] = useState({
    subtotal: 0.0,
    descuento: 0.0,
    exento: 0.0,
    sujeto: 0.0,
    iva: 16.0,
    totaliva: 0.0,
    total: 0.0,
  });


  // Funciones para Bluetooth e impresión
  const checkBluetoothStatus = async () => {
    try {
      if (!navigator.bluetooth) {
        setBluetoothStatus(prev => ({
          ...prev,
          available: false,
          message: 'Su navegador no soporta Bluetooth. Use Chrome en Android.'
        }));
        return;
      }

      const isAvailable = await navigator.bluetooth.getAvailability();

      if (!isAvailable) {
        setBluetoothStatus(prev => ({
          ...prev,
          available: false,
          message: 'El Bluetooth está desactivado. Por favor actívelo.'
        }));
      } else {
        setBluetoothStatus(prev => ({
          ...prev,
          available: true,
          message: 'Bluetooth activado correctamente.'
        }));
        setPrinterStatus(prev => ({
          ...prev,
          statusMessage: 'Bluetooth activado. Busca una impresora.'
        }));
      }
    } catch (error) {
      console.error('Error al verificar Bluetooth:', error);
      setBluetoothStatus(prev => ({
        ...prev,
        available: false,
        message: 'Error al verificar el estado del Bluetooth.'
      }));
    }
  };



  let nomtabla;

  if (operacion === 4) {
    nomtabla = [
      { label: "COD-PRODUCTO", textAlign: "center", width: "40px" },
      { label: "PRODUCTO", textAlign: "center", width: "100px" },
      { label: "CANTIDAD", textAlign: "center", width: "20px" },
      { label: "TIPO PRECIO", textAlign: "center", width: "50px" },
      { label: "PRECIO UNI.", textAlign: "center", width: "50px" },
      { label: "UND. ALT.", textAlign: "center", width: "50px" },
      { label: "MONTO", textAlign: "center", width: "50px" },
      {
        label: "",
        textAlign: "center",
        width: "20px",
      },
    ];
  } else {
    nomtabla = [
      { label: "COD-PRODUCTO", textAlign: "center", width: "40px" },
      { label: "PRODUCTO", textAlign: "center", width: "100px" },
      { label: "EXISTENCIA", textAlign: "center", width: "30px" },
      { label: "CANTIDAD", textAlign: "center", width: "20px" },
      { label: "TIPO PRECIO", textAlign: "center", width: "50px" },
      { label: "PRECIO UNI.", textAlign: "center", width: "50px" },
      { label: "UND. ALT.", textAlign: "center", width: "50px" },
      { label: "MONTO", textAlign: "center", width: "50px" },
      {
        label: <i className="fas fa-trash" />,
        textAlign: "center",
        width: "20px",
      },
    ];
  }

  const headCells = nomtabla;

  const { TblContainer, TblHead } = useTableScroll(headCells);

  const handleSearch = (e) => {
    let target = e.target;
    let lista = [];

    if (target.value === "") {
      lista = todosProductos;
    } else {
      lista = todosProductos.filter((x) => {
        if (
          x.idproducto.includes(target.value) ||
          x.codigo.toLowerCase().includes(target.value.toLowerCase()) ||
          x.nombre.toLowerCase().includes(target.value.toLowerCase()) ||
          x.descripcion.toLowerCase().includes(target.value.toLowerCase()) ||
          formatMoneda(
            x.cantidad.toString().replace(",", "").replace(".", ","),
            ",",
            ".",
            2
          )
            .toLowerCase()
            .includes(target.value.toLowerCase())
        ) {
          return x;
        }
      });
    }

    setListaProductos(lista);
  };

  const validarNumPedido = (event) => {
    event.preventDefault();
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        if (event.target.name === "numpedido") {
          seleccionarRegistro();
        }
      }
    }
  };

  const validarCliente = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (cmbRif.current.value !== "" && event.target.value !== "") {
        let rif = cmbRif.current.value + event.target.value;
        seleccionarCliente(rif, event.which);
      }
    }
  };

  const onCheke = (e) => {
    if (e.target.checked !== false) {
      setVisibl(1);
    } else {
      setVisibl(0);
    }
  };

  const seleccionarRegistros = (id) => {
    let endpoint = `${op.conexion}/api/pedido/productoexisselectubi?idalmacen=${id}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            setListaProductos(response.data);
            setTodosProductos(response.data);
          } else {
            setListaProductos([]);
            setTodosProductos([]);
            setMensaje({
              mostrar: true,
              titulo: "Notificacion",
              texto: "el almacen no tiene productos!",
              icono: "informacion",
            });
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(() => {
        setActivate(false);
      });
  };

  const blanquear = () => {
    setBody();
    setBody2();
    setNumnotaentrega("");
    setNumnotaentregae(0);
    setTituloHeader("Gestionar Venta.");
    setActivate(false);
    setActimprime(0);
    setHabilitado(false);
    setHabilitadoCli(false);
    setHabilitadoBot(false);
    setIdpedi(0);
    setHabilitadoProductos(false);
    setHabilitarMoneda(false);
    setVisibl(0);
    setRecords([]);
    setListaProductos([]);
    setMoneda({
      idmoneda: "1",
      descripcion: "BOLIVARES",
      simbolo: "Bs",
      predeterminada: false,
      valormoneda: 1.0,
    });
    setMonedaCambio({
      idmoneda: "4",
      descripcion: "DOLAR",
      simbolo: "$",
      predeterminada: false,
      subpredeterminada: true,
      valormoneda: 1.0,
    });
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    setCliente({
      idcliente: "",
      tiporif: "J",
      rif: "",
      nombre: "",
    });
    setPedido({
      idpedido: "0",
      numpedido: "000000",
      cedularif: "",
      descripcion: "PEDIDO DE PRODUCTO",
      totalmonto: 0.0,
      totaliva: 0.0,
      totaldescuento: 0.0,
      totalexento: 0.0,
      totalsujeto: 0.0,
      idcliente: "",
      idvendedor: "",
      fecha: moment(fechasistema).format("YYYY-MM-DD"),
      status: 0,
      idalmacen: "",
      idmoneda: "",
      idoperacioninventario: "",
    });
    setTotales({
      subtotal: 0.0,
      descuento: 0.0,
      exento: 0.0,
      sujeto: 0.0,
      iva: 16.0,
      totaliva: 0.0,
      total: 0.0,
    });
    for (let i = 0; i < combomoneda.length; i++) {
      if (combomoneda[i].idmoneda === monedaSub.idmoneda) {
        cmbMoneda.current.selectedIndex = i;
      }
    }

    if (operacion !== 1) {
      txtStatus.current.value = "0";
    }
    setOperacion(1);
    cmbRif.current.selectedIndex = -1;
    txtRif.current.value = "";
    txtNombreC.current.value = "";
    txtFecha.current.value = "";
    txtNumPedido.current.value = "";
    txtNumPedido.current.setAttribute("disabled", true);
    txtCredito.current.checked = false;
    txtIdnota.current.value = '';
    txtNunnota.current.value = '';

    seleccionarMonedas();
    seleccionarVendedor(idagente);
  };

  const seleccionarMonedas = () => {
    let campos =
      "m.idmoneda, m.descripcion, m.simbolo, m.predeterminada,  m.subpredeterminada, md.valor as valormoneda, md.fecha";
    let nomtab =
      "moneda as m left join monedadetalle as md on m.idmoneda=md.idmoneda where md.fecha = (SELECT MAX(fecha) AS fecha FROM monedadetalle where idmoneda=m.idmoneda)";
    let orden = "m.idmoneda";

    let endpoint = `${op.conexion}/api/comun/seleccionaregistros?&campos=${campos}&nomtab=${nomtab}&orden=${orden}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          let x = 0;
          if (response.data.length > 0) {
            setComboMoneda(response.data);
            for (let i = 0; i < response.data.length; i++) {
              if (response.data[i].subpredeterminada) {
                setMonedaSub(response.data[i]);
                setMonedaCambio({
                  idmoneda: response.data[i].idmoneda,
                  descripcion: response.data[i].descripcion,
                  simbolo: response.data[i].simbolo,
                  predeterminada: response.data[i].predeterminada,
                  subpredeterminada: response.data[i].subpredeterminada,
                  valormoneda: 1.0,
                });
                x = i;
              } else if (response.data[i].predeterminada) {
                setMoneda(response.data[i]);
              }
            }
            selectnumfactu();
            selectnumPedido();
          }
          setTimeout(() => (cmbMoneda.current.selectedIndex = x), 200);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(() => {
        setActivate(false);
      });
  };

  const procesarRegistro = () => {
    setActivate(true);
    let endpoint = `${op.conexion}/api/pedido/actualizarnotaentrega/${operacion}`;
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (operacion === 1) {
            if (visibl !== 0) {
              procesarRegistroNota();
            } else {
              setMostrar1(true);
            }
          } else if (operacion === 2) {
            if (visibl !== 0) {
              procesarRegistroNota();
            } else {
              setMostrar1(true);
            }
          } else if (operacion === 3) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto:
                "registro " + response.data.idpe + " eliminado correctamente",
              icono: "exito",
            });
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(() => {
        setActivate(false);
      });
  };

  const procesarRegistroNota = () => {
    let endpoint = `${op.conexion}/api/inventario/actualizarpostventas/${1}`;
    axios
      .post(endpoint, body2, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (operacion !== 4) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "Venta a Crédito Registrada Correctamente",
              icono: "exito",
            });
          }
          setActivate(false);
        }
      })
      .catch(function (error) {
        let mensaje = error.response.data.message;
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: mensaje,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const validarCantidadP = (index) => (event) => {
    validaMonto(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      let cantidades = validarCantidad({
        index: index,
        event: event,
        productos: records,
      });
      if (event.which === 13) {
        txtIdproducto.current.value = '';
        if (index < cantidades.data.length - 1) {
          setTimeout(() => txtCantidad.current[index + 1].focus(), 300);
        } else {
          setTimeout(() => txtIdproducto.current.focus(), 200);
        }
      }
      setMensaje(cantidades.msm);
      setRecords(cantidades.data);
      setTotales(cantidades.totales);
    }
  };


  const generateSimpleTestTicket = async () => {
    try {
      console.log('🎫 Enviando ticket de prueba a la impresora...');

      // Esto es lo mínimo que necesitas para hacer imprimir algo
      const ESC = '\x1B';
      const LF = '\n';

      let ticket = '';

      // Inicializar impresora
      ticket += ESC + '@';

      // Texto SUPER simple
      ticket += '========================' + LF;
      ticket += '   TICKET DE PRUEBA' + LF;
      ticket += '========================' + LF + LF;
      ticket += '🚀 ¡SI IMPRIME ESTO,' + LF;
      ticket += 'LA IMPRESORA FUNCIONA!' + LF + LF;
      ticket += 'Fecha: ' + new Date().toLocaleDateString() + LF;
      ticket += 'Hora: ' + new Date().toLocaleTimeString() + LF + LF;
      ticket += '========================' + LF;

      // Corte automático (si tu impresora lo soporta)
      ticket += LF + LF + LF;
      ticket += ESC + 'i';
      // O también puedes probar con:
      // ticket += '\x1D\x56\x00'; // Corte parcial

      console.log('Contenido a imprimir:', ticket);

      // Aquí va la magia - depende de cómo estés conectado a la impresora

      // Si usas WebUSB:
      // await printViaWebUSB(ticket);

      // Si usas WebSocket:
      // await printViaWebSocket(ticket);

      // Si usas una API:
      // await printViaAPI(ticket);

      console.log('✅ Ticket enviado a impresora');

    } catch (error) {
      console.error('❌ Error:', error);
    }
  };


  const imprimirPedido = () => {

    const tiporeppedido = JSON.parse(sessionStorage.getItem("tiporeppedido"));

    const reportePedido = tiporeppedido.toString() === 'HOJA' ? 'Pedido' : 'ForPedidoMedium'

    if (accbtnpedidos && accbtnpedidos.toString().substring(4, 5) === "1") {
      if (txtNumPedido.current.value !== "") {
        window.open(
          `${op.reportes}/pedidos?afiliado=${organizacion}&reporte=${reportePedido}&CODIGO=${pedido.idpedido}`,
          "Planilla",
          "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
        );
      }
    } else {
      setMensaje({
        mostrar: true,
        titulo: "Notificación.",
        texto: "¡No Posee Permiso para Realizar esta Acción!",
        icono: "error",
      });
    }
  };

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    procesarRegistro();
  };

  const seleccionarCliente = (rif, tecla) => {
    let campos =
      "c.idagente, c.nombre as nombrec, substring(trim(c.rif), 1, 1) as tiporifc, substring(trim(c.rif), 2, 10) as rifc";
    let nomtab = "agente as c";
    let nomid = "c.rif";
    let nomid2 = "c.cliente";
    let id = rif;
    let endpoint = `${op.conexion}/api/consulta/modeli2?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}&nomid2=${nomid2}&id2=true`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            txtNombreC.current.value = response.data.nombrec;
            setCliente({
              idcliente: response.data.idagente,
              tiporif: response.data.tiporifc,
              rif: response.data.rifc,
              nombre: response.data.nombrec,
            });
            setTimeout(() => txtIdproducto.current.focus(), 200);
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "No existe un cliente con este codigo",
              icono: "informacion",
            });
            txtRif.current.value = "";
            cmbRif.current.selectedIndex = -1;
            if (tecla === 13) {
              txtRif.current.focus();
            }
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const seleccionarVendedor = (idage) => {
    let campos =
      "v.idagente, c.idagente as idagentec, v.nombre as nombrev,substring(trim(v.rif), 1, 1) as tiporifv, substring(trim(v.rif), 2, 10) as rifv, v.idalmacen, c.nombre as nombrec,substring(trim(c.rif), 1, 1) as tiporifc, substring(trim(c.rif), 2, 10) as rifc";
    let nomtab = "agente as v inner join agente c on c.generico = true";
    let nomid = "v.idagente";
    let nomid2 = "v.vendedor";
    let id = idage;
    let endpoint = `${op.conexion}/api/consulta/modeli2?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}&nomid2=${nomid2}&id2=true`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data !== "") {

            if (accbtnpedidos && accbtnpedidos.toString().substring(0, 1) === "1") {
              setTituloHeader("Incluir Venta.");
              setHabilitado(true);
              setHabilitadoCli(true);
              setHabilitadoProductos(false);
              setHabilitarMoneda(true);
              setHabilitadoBot(false);
              txtFecha.current.value = moment(fechasistema).format("YYYY-MM-DD");
            } else {
              setMensaje({
                mostrar: true,
                titulo: "Notificación.",
                texto: "¡No Posee Permiso para Realizar Ventas!",
                icono: "error",
              });
            }
            setVendedor({
              idvendedor: response.data.idagente,
              tiporif: response.data.tiporifv,
              rif: response.data.rifv,
              nombre: response.data.nombrev,
              idalmacen: response.data.idalmacen,
            });
            cmbRif.current.value = response.data.tiporifc;
            txtRif.current.value = response.data.rifc;
            txtNombreC.current.value = response.data.nombrec;
            setCliente({
              idcliente: response.data.idagentec,
              tiporif: response.data.tiporifc,
              rif: response.data.rifc,
              nombre: response.data.nombrec,
            });
            if (
              response.data.idalmacen === null ||
              response.data.idalmacen === "" ||
              response.data.idalmacen === 0
            ) {
              setListaProductos([]);
              setTodosProductos([]);
              setRecords([]);
              setMensaje({
                mostrar: true,
                titulo: "Notificacion",
                texto: "el vendedor no tiene un almacen asociado!",
                icono: "informacion",
              });
            } else {
              seleccionarRegistros(response.data.idalmacen);
            }
            setTimeout(() => txtIdproducto.current.focus(), 300);
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "No existe un vendedor con este codigo",
              icono: "informacion",
            });
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const seleccionarRegistro = () => {

    const endpoint = `${op.conexion}/api/inventario/seleccionarpedidopost?&numpedido=${"'" + txtNumPedido.current.value.trim().toUpperCase() + "'"}`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data !== "") {

            setPedido({
              idpedido: response.data.idpedido,
              numpedido: response.data.numpedido,
              cedularif: response.data.cedularif,
              descripcion: response.data.descripcion,
              totalmonto: response.data.totalmonto,
              totaliva: response.data.totaliva,
              totaldescuento: response.data.totaldescuento,
              totalexento: response.data.totalexento,
              totalsujeto: response.data.totalsujeto,
              idcliente: response.data.idcliente,
              idvendedor: response.data.idvendedor,
              fecha: moment(response.data.fechapedido).format("YYYY-MM-DD"),
              status: response.data.status,
              idalmacen: response.data.idalmacen,
              idmoneda: response.data.idmoneda,
              idoperacioninventario: response.data.idoperacioninventario,
            });

            setMoneda({
              idmoneda: response.data.idmoneda,
              descripcion: response.data.descripcion,
              simbolo: response.data.simbolo,
              valormoneda: response.data.valormoneda,
              predeterminada: response.data.predeterminada,
              subpredeterminada: response.data.subpredeterminada,
            });

            setCliente({
              idcliente: response.data.idcliente,
              tiporif: response.data.tiporifc,
              rif: response.data.rifc,
              nombre: response.data.nombrec,
            });
            cmbRif.current.value = response.data.tiporifc;
            txtRif.current.value = response.data.rifc;
            txtNombreC.current.value = response.data.nombrec;

            setVendedor({
              idvendedor: response.data.idvendedor,
              tiporif: response.data.tiporifv,
              rif: response.data.rifv,
              nombre: response.data.nombrev,
              idalmacen: response.data.idalmacen,
            });

            if (
              response.data.idalmacen === null ||
              response.data.idalmacen === "" ||
              response.data.idalmacen === 0
            ) {
              setListaProductos([]);
              setTodosProductos([]);
              setRecords([]);
              setMensaje({
                mostrar: true,
                titulo: "Notificacion",
                texto: "el vendedor no tiene un almacen asociado!",
                icono: "informacion",
              });
            } else {
              seleccionarRegistros(response.data.idalmacen);
            }
            txtNumPedido.current.setAttribute("disabled", true);
            if (operacion !== 1) { txtStatus.current.value = response.data.status; }
            txtFecha.current.value = moment(response.data.fechapedido).format(
              "YYYY-MM-DD"
            );
            for (let i = 0; i < combomoneda.length; i++) {
              if (response.data.idmoneda === combomoneda[i].idmoneda) {
                cmbMoneda.current.selectedIndex = i;
                break;
              }
            }
            txtIdnota.current.value = response.data.idnotaentregad;
            txtNunnota.current.value = response.data.numnotaentregad;
            seleccionarDetalle(response.data.idpedido);
            setTotales({
              subtotal: response.data.totalmonto - response.data.totaliva,
              descuento: response.data.totaldescuento,
              exento: response.data.totalexento,
              sujeto: response.data.totalsujeto,
              iva: 16.0,
              totaliva: response.data.totaliva,
              total: response.data.totalmonto,
            });

            if (operacion === 2) {
              setHabilitado(true);
              setHabilitarMoneda(true);
              setHabilitadoCli(true);
              setTimeout(() => txtIdproducto.current.focus(), 200);
            } else {
              setHabilitado(false);
              setHabilitadoCli(false);
              setTimeout(() => txtIdproducto.current.focus(), 200);
            }
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "no existe un pedido con ese codigo.",
              icono: "informacion",
            });
            txtNumPedido.current.value = "";
            txtNumPedido.current.focus();
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        console.log(error);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const seleccionarDetalle = (idpedido) => {
    let nomtab1 = "pedidodetalle";
    let nomtab2 = "pedido";
    let nomid = "idpedido";
    let endpoint = `${op.conexion}/api/inventario/seleccionarnotaentregadet?id=${idpedido}&nomtab1=${nomtab1}&nomtab2=${nomtab2}&nomid=${nomid}`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            let prod = [];
            let uni = [];
            let montoiva = 0.0;
            let cantie = 0.0;
            let cantiea = 0.0;
            let tipouni = 0;
            let tiene_iva = false;

            for (let i = 0; i < response.data.length; i++) {
              if (parseFloat(response.data[i].iva) > 0.0) {
                tiene_iva = true;
              }
              if (
                response.data[i].tipounidad === 0 &&
                parseFloat(response.data[i].valorfactor) <= 0.0
              ) {
                tipouni = 0;
                uni = [
                  {
                    idunidad: response.data[i].idunidadmedida,
                    descripcion: response.data[i].descripcionuni,
                    tipo: "medida",
                  },
                ];

                cantie =
                  parseFloat(response.data[i].cantidade) +
                  parseFloat(response.data[i].cantidad);
                cantie = Math.trunc(cantie);

                cantiea =
                  parseFloat(response.data[i].cantidade) +
                  parseFloat(response.data[i].cantidad);
                cantiea = Math.trunc(cantiea);
              } else if (
                response.data[i].tipounidad === 0 &&
                parseFloat(response.data[i].valorfactor) > 0.0
              ) {
                tipouni = 0;
                uni = [
                  {
                    idunidad: response.data[i].idunidadmedida,
                    descripcion: response.data[i].descripcionuni,
                    tipo: "medida",
                  },
                  {
                    idunidad: response.data[i].idunidadalterna,
                    descripcion: response.data[i].descripcionunialt,
                    tipo: "alterna",
                  },
                ];

                cantie =
                  parseFloat(response.data[i].cantidade) /
                  parseFloat(response.data[i].valorfactor) +
                  parseFloat(response.data[i].cantidad);
                cantie = Math.trunc(cantie);

                cantiea =
                  parseFloat(response.data[i].cantidade) /
                  parseFloat(response.data[i].valorfactor) +
                  parseFloat(response.data[i].cantidad);

                cantiea = cantiea * parseFloat(response.data[i].valorfactor);
                cantiea = Math.trunc(cantiea);
              } else if (response.data[i].tipounidad === 1) {
                tipouni = 1;
                uni = [
                  {
                    idunidad: response.data[i].idunidadalterna,
                    descripcion: response.data[i].descripcionunialt,
                    tipo: "alterna",
                  },
                  {
                    idunidad: response.data[i].idunidadmedida,
                    descripcion: response.data[i].descripcionuni,
                    tipo: "medida",
                  },
                ];

                cantie =
                  parseFloat(response.data[i].cantidade) +
                  parseFloat(response.data[i].cantidad);
                cantie = Math.trunc(cantie);

                cantiea =
                  parseFloat(response.data[i].cantidade) +
                  parseFloat(response.data[i].cantidad);
                cantiea = Math.trunc(cantiea);
              }

              prod.push({
                idproducto: response.data[i].idproducto,
                codigo: response.data[i].codigo,
                cantidad: response.data[i].cantidad,
                cantidadE: parseFloat(cantie),
                cantidadEA: parseFloat(cantiea),
                nombrecorto: `${response.data[i].nombrecorto} ${tiene_iva ? "" : " (E)"
                  }`,
                precio: response.data[i].punitario,
                preciobs: response.data[i].punitariobs,
                preciomaxi: response.data[i].preciomaxi,
                precioofe: response.data[i].precioofe,
                preciomayor: response.data[i].preciomayor,
                preciomini: response.data[i].preciomini,
                preciomaxialter: response.data[i].preciomaxialter,
                precioofealter: response.data[i].precioofealter,
                preciomayoralter: response.data[i].preciomayoralter,
                preciominialter: response.data[i].preciominialter,
                iva: response.data[i].iva,
                ivaventa: response.data[i].ivaventa,
                montoiva: response.data[i].cantidad * montoiva,
                descuento: response.data[i].descuento,
                total: response.data[i].cantidad * response.data[i].punitario,
                unidad: uni,
                idunidadmedida: response.data[i].idunidadmedida,
                idunidadalterna: response.data[i].idunidadalterna,
                costocalculado: response.data[i].costocalculado,
                costocalculadoalter: response.data[i].costocalculadoalter,
                utipreciomaxi: response.data[i].utipreciomaxi,
                utipreciomaxialter: response.data[i].utipreciomaxialter,
                tipounidad: tipouni,
                valormoneda: monedaCambio.valormoneda,
                idmoneda: response.data[i].idmoneda,
                tipofactor: response.data[i].tipofactor,
                valorfactor: response.data[i].valorfactor,
                tipoprecio: response.data[i].tipopreciodeta,
              });
            }

            setRecords(prod);
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const onCatalogoCliente = (values) => {
    setCatalogoCliente(false);
    if (tipoAgente === "cliente") {
      cmbRif.current.value = values.rif.substring(0, 1);
      txtRif.current.value = values.rif.substring(1);
      seleccionarCliente(values.rif);
    } else {
      setVendedor({
        idvendedor: values.idagente,
        tiporif: values.rif.substring(0, 1),
        rif: values.rif.substring(1),
        nombre: values.nombre,
        idalmacen: values.idalmacen,
      });
      if (
        values.idalmacen === null ||
        values.idalmacen === "" ||
        values.idalmacen === 0
      ) {
        setListaProductos([]);
        setTodosProductos([]);
        setRecords([]);
        setMensaje({
          mostrar: true,
          titulo: "Notificacion",
          texto: "el vendedor no tiene un almacen asociado!",
          icono: "informacion",
        });
      } else {
        seleccionarRegistros(values.idalmacen);
      }
    }
  };

  const oncatalogoPedidoEntrega = (values) => {
    setCatalogoPedido(false);
    if (values !== "") {
      txtNumPedido.current.value = values.numpedido;
      seleccionarRegistro();
      setActimprime(1);
      setOperacion(2);
    } else {
      setActimprime(0);
    }
  };

  const onChangeMoneda = (e) => {
    let i = e.target.value;
    const cambio = onCambioMoneda({
      moneda: combomoneda[i],
      productos: records,
      monedaPre: moneda,
      monedaSub: monedaSub,
    });
    setMonedaCambio(cambio.monedacambio);
    setRecords(cambio.data);
  };

  const onChangeUnidad = (i) => (e) => {
    let cambiounidad = onCambioUnidad({
      idunidad: e.target.value,
      index: i,
      productos: records,
    });
    setMensaje(cambiounidad.msm);
    setRecords(cambiounidad.data);
    setTotales(cambiounidad.totales);
  };

  const onChangeTipoPrecio = (i) => (e) => {
    let data = [...records];
    let tipoprecio = parseInt(e.target.value);
    let tipounidad = data[i].tipounidad;
    let cantidad = data[i].cantidad;
    let precio = 0.0;
    let total = 0.0;

    if (tipounidad === 1) {
      if (tipoprecio === 1) {
        precio = parseFloat(data[i].preciomaxialter);
      } else if (tipoprecio === 2) {
        precio = parseFloat(data[i].precioofealter);
      } else if (tipoprecio === 3) {
        precio = parseFloat(data[i].preciomayoralter);
      } else if (tipoprecio === 4) {
        precio = parseFloat(data[i].preciominialter);
      }
    } else {
      if (tipoprecio === 1) {
        precio = parseFloat(data[i].preciomaxi);
      } else if (tipoprecio === 2) {
        precio = parseFloat(data[i].precioofe);
      } else if (tipoprecio === 3) {
        precio = parseFloat(data[i].preciomayor);
      } else if (tipoprecio === 4) {
        precio = parseFloat(data[i].preciomini);
      }
    }

    total = precio * cantidad;

    data[i].tipoprecio = e.target.value;
    data[i].precio = precio;
    data[i].total = total;

    setRecords(data);
    setTotales(calcularTotales(data));
  };

  const seleccionarProducto = (index, idubi, idprod) => {
    let endpoint = `${op.conexion
      }/api/inventario/seleccionarproductoinv?idproducto='${idprod.toUpperCase()}'&idalmacen=${idubi}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          let data = [...records];
          if (response.data !== "") {

            for (let e = 0; e < records.length; e++) {

              let valcantidad = parseFloat(response.data.cantidad) <= 0 ? 0 : 1;
              if (records[e].idproducto === response.data.idproducto && valcantidad <= 0) {
                setMensaje({
                  mostrar: true,
                  titulo: "Notificacion",
                  texto: "¡Este Producto no Cuenta con Existencia!.",
                  icono: "error",
                });
                txtIdproducto.current.value = '';
                setTimeout(() => txtIdproducto.current.focus(), 200);
                return
              }

            }

            if (response.data.servicio) {
              setMensaje({
                mostrar: true,
                titulo: "Notificacion",
                texto: "No existe un Producto con ese Código en el Almacen.",
                icono: "error",
              });
              txtIdproducto.current.value = '';
              setTimeout(() => txtIdproducto.current.focus(), 200);
            } else {
              let unis = [];
              for (let i = 0; i < records.length; i++) {

                if (records[i].idproducto === response.data.idproducto) {
                  let valcantidad = parseFloat(records[i].cantidad + 1) > parseFloat(response.data.cantidad) ? 0 : parseFloat(response.data.cantidad) <= 0 ? 0 : 1;
                  if (valcantidad <= 0) {
                    setMensaje({
                      mostrar: true,
                      titulo: "Notificacion",
                      texto: "¡Este Producto no Cuenta con Existencia!.",
                      icono: "error",
                    });
                    txtIdproducto.current.value = '';
                    setTimeout(() => txtIdproducto.current.focus(), 200);
                    return
                  }

                  if (
                    parseInt(response.data.tipofactor) === 0 ||
                    response.data.tipofactor === null
                  ) {
                    tipouni = 0;
                    unis = [
                      {
                        idunidad: response.data.idunidadmedida,
                        descripcion: response.data.descripcionuni,
                        tipo: "medida",
                      },
                    ];

                    cantie = parseFloat(response.data.cantidad);
                    cantie = Math.trunc(cantie);
                  } else {
                    tipouni = 1;
                    unis = [
                      {
                        idunidad: response.data.idunidadalterna,
                        descripcion: response.data.descripcionunialt,
                        tipo: "alterna",
                      },
                      {
                        idunidad: response.data.idunidadmedida,
                        descripcion: response.data.descripcionuni,
                        tipo: "medida",
                      },
                    ];

                    cantie = parseFloat(response.data.cantidad);
                    cantie = Math.trunc(cantie);
                  }

                  let tipoprecioActual = tipopre && parseInt(tipopre.tipoprecio) > 0 ?
                    parseInt(tipopre.tipoprecio) : records[i].tipoprecio;

                  data[i] = {
                    idproducto: records[i].idproducto,
                    codigo: records[i].codigo,
                    cantidad: records[i].cantidad + 1,
                    cantidadE: cantie,
                    cantidadEA: parseFloat(records[i].cantidad),
                    nombrecorto: records[i].nombrecorto,
                    precio: records[i].precio,
                    preciobs: 0.0,
                    preciomaxi: records[i].preciomaxi,
                    precioofe: records[i].precioofe,
                    preciomayor: records[i].preciomayor,
                    preciomini: records[i].preciomini,
                    preciomaxialter: records[i].preciomaxialter,
                    precioofealter: records[i].precioofealter,
                    preciomayoralter: records[i].preciomayoralter,
                    preciominialter: records[i].preciominialter,
                    iva: records[i].iva,
                    montoiva: records[i].montoiva,
                    descuento: 0.0,
                    total: records[i].precio * (records[i].cantidad + 1),
                    idunidadmedida: records[i].idunidadmedida,
                    idunidadalterna: records[i].idunidadalterna,
                    unidad: unis,
                    idmoneda: records[i].idmoneda,
                    valormoneda: records[i].valormoneda,
                    tipounidad: records[i].tipounidad,
                    tipofactor: records[i].tipofactor,
                    valorfactor: records[i].valorfactor,
                    tipoprecio: tipoprecioActual,
                  };

                  setRecords(data);
                  setTotales(calcularTotales(data));
                  setIndice(i);
                  if (i !== null) {
                    txtIdproducto.current.value = '';
                    setTimeout(() => txtIdproducto.current.focus(), 200);
                  } else {
                    txtIdproducto.current.value = '';
                    setTimeout(() => txtIdproducto.current.focus(), 200);
                  }
                  return

                }
              }

              let uni = [];
              let precio = 0.0;
              let montoiva = 0.0;
              let cantie = response.data.cantidad;
              let tipouni = 0;
              let tiene_iva = false;

              let tipoprecio = tipopre && parseInt(tipopre.tipoprecio) > 0 ?
                parseInt(tipopre.tipoprecio) : parseInt(response.data.tipoprecio);

              if (parseFloat(response.data.ivaventa) > 0.0) {
                tiene_iva = true;
              }

              if (
                parseInt(response.data.tipofactor) === 0 ||
                response.data.tipofactor === null
              ) {
                tipouni = 0;
                uni = [
                  {
                    idunidad: response.data.idunidadmedida,
                    descripcion: response.data.descripcionuni,
                    tipo: "medida",
                  },
                ];

                cantie = parseFloat(response.data.cantidad);
                cantie = Math.trunc(cantie);

                if (tipoprecio === 1) {
                  precio = parseFloat(response.data.preciomaxi);
                } else if (tipoprecio === 2) {
                  precio = parseFloat(response.data.precioofe);
                } else if (tipoprecio === 3) {
                  precio = parseFloat(response.data.preciomayor);
                } else if (tipoprecio === 4) {
                  precio = parseFloat(response.data.preciomini);
                }
              } else {
                tipouni = 1;
                uni = [
                  {
                    idunidad: response.data.idunidadalterna,
                    descripcion: response.data.descripcionunialt,
                    tipo: "alterna",
                  },
                  {
                    idunidad: response.data.idunidadmedida,
                    descripcion: response.data.descripcionuni,
                    tipo: "medida",
                  },
                ];

                cantie = parseFloat(response.data.cantidad);
                cantie = Math.trunc(cantie);
                if (tipoprecio === 1) {
                  precio = parseFloat(response.data.preciomaxialter);
                } else if (tipoprecio === 2) {
                  precio = parseFloat(response.data.precioofealter);
                } else if (tipoprecio === 3) {
                  precio = parseFloat(response.data.preciomayoralter);
                } else if (tipoprecio === 4) {
                  precio = parseFloat(response.data.preciominialter);
                }
              }

              if (index !== null) {
                data[index] = {
                  idproducto: response.data.idproducto,
                  codigo: response.data.codigo,
                  cantidad: 1.0,
                  cantidadE: cantie,
                  cantidadEA: parseFloat(response.data.cantidad),
                  nombrecorto: `${response.data.nombrecorto} ${tiene_iva ? "" : " (E)"
                    }`,
                  precio: precio,
                  preciobs: 0.0,
                  preciomaxi: response.data.preciomaxi,
                  precioofe: response.data.precioofe,
                  preciomayor: response.data.preciomayor,
                  preciomini: response.data.preciomini,
                  preciomaxialter: response.data.preciomaxialter,
                  precioofealter: response.data.precioofealter,
                  preciomayoralter: response.data.preciomayoralter,
                  preciominialter: response.data.preciominialter,
                  iva: response.data.ivaventa,
                  montoiva: montoiva,
                  descuento: 0.0,
                  total: precio,
                  unidad: uni,
                  idunidadmedida: response.data.idunidadmedida,
                  idunidadalterna: response.data.idunidadalterna,
                  idunidadventa: response.data.idunidadventa,
                  idmoneda: response.data.idmoneda,
                  valormoneda: monedaCambio.valormoneda,
                  tipounidad: tipouni,
                  tipofactor: response.data.tipofactor,
                  valorfactor: response.data.valorfactor,
                  tipoprecio: tipoprecio.toString(),
                };
                setRecords(data);
                setTotales(calcularTotales(data));
                setIndice(index);

                if (index !== null) {
                  setIndexs(0);
                  txtIdproducto.current.value = '';
                  setTimeout(() => txtIdproducto.current.focus(), 200);
                } else {
                  txtIdproducto.current.value = '';
                  setTimeout(() => txtIdproducto.current.focus(), 200);
                }
              } else {
                data.push({
                  idproducto: response.data.idproducto,
                  codigo: response.data.codigo,
                  cantidad: 1.0,
                  cantidadE: cantie,
                  cantidadEA: parseFloat(response.data.cantidad),
                  nombrecorto: `${response.data.nombrecorto} ${tiene_iva ? "" : " (E)"
                    }`,
                  precio: precio,
                  preciomaxi: response.data.preciomaxi,
                  precioofe: response.data.precioofe,
                  preciomayor: response.data.preciomayor,
                  preciomini: response.data.preciomini,
                  preciomaxialter: response.data.preciomaxialter,
                  precioofealter: response.data.precioofealter,
                  preciomayoralter: response.data.preciomayoralter,
                  preciominialter: response.data.preciominialter,
                  preciobs: 0.0,
                  iva: response.data.ivaventa,
                  montoiva: montoiva,
                  descuento: 0.0,
                  total: precio,
                  unidad: uni,
                  idunidadmedida: response.data.idunidadmedida,
                  idunidadalterna: response.data.idunidadalterna,
                  idunidadventa: response.data.idunidadventa,
                  idmoneda: response.data.idmoneda,
                  valormoneda: monedaCambio.valormoneda,
                  tipounidad: tipouni,
                  tipofactor: response.data.tipofactor,
                  valorfactor: response.data.valorfactor,
                  tipoprecio: tipoprecio.toString(),
                });
                setRecords(data);
                setTotales(calcularTotales(data));
                setIndice(index);

                if (index !== null) {
                  setIndexs(0);
                  txtIdproducto.current.value = '';
                  setTimeout(() => txtIdproducto.current.focus(), 200);
                } else {
                  txtIdproducto.current.value = '';
                  setTimeout(() => txtIdproducto.current.focus(), 200);
                }
              }
            }
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificacion",
              texto: "no existe un producto con ese codigo en el almacen.",
              icono: "error",
            });
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const validarIdProducto = (index) => (event) => {
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        if (vendedor.idalmacen !== "" && vendedor.idalmacen !== null) {
          seleccionarProducto(index, vendedor.idalmacen, event.target.value);
        } else {
          setMensaje({
            mostrar: true,
            titulo: "Notificación.",
            texto: "debe seleccionar un vendedor.",
            icono: "informacion",
          });
        }
      }
    }
  };

  const agregarProducto = (producto) => {
    seleccionarProducto(indice, vendedor.idalmacen, producto.codigo);
    setMostrar(false);
  };

  const eliminarProducto = (producto) => (e) => {
    e.preventDefault();
    let data = [...records];
    let elementos = [];

    for (let i = 0; i < data.length; i++) {
      if (producto.idproducto !== data[i].idproducto) {
        elementos.push(data[i]);
        txtIdproducto.current.value = '';
        setTimeout(() => txtIdproducto.current.focus(), 200);
      } else {
        txtIdproducto.current.value = '';
        setTimeout(() => txtIdproducto.current.focus(), 200);
      }
    }
    setRecords(elementos);
    setTotales(calcularTotales(elementos));
  };

  const seleccionarxIndice = (index) => (e) => {
    e.preventDefault();
    if (vendedor.idalmacen !== "" && vendedor.idalmacen !== null) {
      setMostrar(true);
      setIndice(index);
    } else {
      setMensaje({
        mostrar: true,
        titulo: "Notificación.",
        texto: "debe seleccionar un vendedor.",
        icono: "informacion",
      });
    }
  };

  const handleInputChange = (event) => {
    event.preventDefault();
    if (event.which === 13) {
      if (event.target.name === "fecha") {
        event.target.value = moment(event.target.value).format("YYYY-MM-DD");
        btnProducto.current.focus();
      }
    } else if (typeof event.which === "undefined") {
      if (event.target.name === "fecha") {
        event.target.value = moment(event.target.value).format("YYYY-MM-DD");
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const onChangeValidar = () => {
    let sigue = true;

    if (bluetoothStatus.checked) {
      // 2. ¿La impresora NO está conectada?
      if (!printerStatus.connected) {
        setMensaje({
          mostrar: true,
          titulo: "Impresora Requerida",
          texto: "El sistema detectó que Bluetooth está activo, pero la impresora no está conectada. Por favor conecte la impresora antes de procesar el pago.",
          icono: "informacion"
        });
        sigue = false; // Detenemos el proceso aquí
      }
    }


    if (
      cmbRif.current.value === "" ||
      txtRif.current.value.trim() === "" ||
      txtNombreC.current.value === ""
    ) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El Cliente no debe estar vacio",
        icono: "informacion",
      });
      sigue = false;
      txtRif.current.focus();
    } else if (txtFecha.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "La Fecha no debe estar vacia",
        icono: "informacion",
      });
      sigue = false;
      txtFecha.current.focus();
    } else if (records.length === 0) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "No hay Productos agregados",
        icono: "informacion",
      });
      sigue = false;
      setTimeout(() => txtIdproducto.current.focus(), 200);
    } else if (records.length > 0 && operacion !== 3) {
      for (let i = 0; i < records.length; i++) {
        if (records[i].cantidadE === 0.0) {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "La  cantidad no debe ser mayor a la cantidad existente",
            icono: "informacion",
          });
          sigue = false;
          setTimeout(() => txtIdproducto.current.focus(), 200);
          break;
        } else if (records[i].cantidadE < records[i].cantidad) {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "La  cantidad no debe ser mayor a la cantidad existente",
            icono: "informacion",
          });
          sigue = false;
          setTimeout(() => txtIdproducto.current.focus(), 200);
          break;
        }
      }
    }

    if (sigue) {
      let pedi = [];
      let pedidet = [];
      let opeinv = [];
      let opeinvdet = [];
      let notae = [];
      let notaedet = [];

      pedi.push({
        idpedido: pedido.idpedido,
        numpedido: pedido.numpedido,
        cedularif: cliente.tiporif + cliente.rif,
        descripcion: "VENTA DE PRODUCTOS",
        totalmonto: totales.total,
        totaliva: totales.totaliva,
        totaldescuento: totales.descuento,
        totalsujeto: totales.sujeto,
        totalexento: totales.exento,
        idcliente: cliente.idcliente,
        idvendedor: vendedor.idvendedor,
        fecha: txtFecha.current.value,
        status: pedido.status,
        idalmacen: vendedor.idalmacen,
        idmoneda: monedaSub.idmoneda,
        idoperacioninventario: pedido.idoperacioninventario,
      });

      opeinv.push({
        idoperacioninventario:
          pedido.idoperacioninventario === null ||
            pedido.idoperacioninventario === ""
            ? "0"
            : pedido.idoperacioninventario,
        tipooperacion: "SALIDA",
        idalmacenorigen: vendedor.idalmacen,
        idalmacendestino: "",
        fecha: txtFecha.current.value,
        idmoneda: monedaSub.idmoneda,
        observacion: "PEDIDO",
      });

      notae.push({
        idnotaentrega: operacion === 2 && txtIdnota.current.value !== '' ? parseInt(txtIdnota.current.value) : 0,
        numnotaentrega: operacion === 2 && txtNunnota.current.value !== '' ? txtNunnota.current.value : numnotaentrega,
        numpedido: operacion === 1 ? txtNumPedido.current.value : pedido.numpedido,
        descripcion: "NOTA DE ENTREGA DE PRODUCTOS",
        cedularif: cliente.tiporif + cliente.rif,
        tipo: "NE",
        totalmonto: totales.total,
        totaliva: totales.totaliva,
        totalexento: totales.exento,
        totalsujeto: totales.sujeto,
        totaldescuento: totales.descuento,
        idpedido: operacion === 1 ? idpedi : pedido.idpedido,
        idcliente: cliente.idcliente,
        idvendedor: vendedor.idvendedor,
        fecha: txtFecha.current.value,
        status: operacion !== 4 && visibl !== 0 ? 0 : 1,
        idalmacen: vendedor.idalmacen,
        idmoneda: monedaSub.idmoneda,
        idoperacioninventario: "",
        credito: visibl !== 0 ? true : false,
        fechavencimiento: visibl !== 0 ? txtFechaVence.current.value : null,
        facturado: 0
      });
      setNotaen(notae);
      let valnot = txtIdnota.current.value !== '' ? 1 : 0;
      setNumnotaentregae(valnot);

      for (let i = 0; i < records.length; i++) {
        pedidet.push({
          idproducto: records[i].idproducto,
          cantidad: records[i].cantidad,
          iva: records[i].iva,
          punitario: records[i].precio,
          descuento: "0.00",
          tipounidad: records[i].tipounidad,
          idunidadmedida: records[i].idunidadmedida,
          idunidadalterna: records[i].idunidadalterna,
          tasa: monedaSub.valormoneda,
          codproducto: records[i].codigo,
          costo: records[i].costocalculado,
          utilidad: records[i].utipreciomaxi,
          tipopreciodeta: records[i].tipoprecio,
        });

        opeinvdet.push({
          idproducto: records[i].idproducto,
          nombre: records[i].nombrecorto,
          cantidad: records[i].cantidad,
          precio: records[i].precio,
          fechavencimiento: "",
          tipomovimiento: "VENTA",
          fechatipomovimiento: txtFecha.current.value,
          numfactura: pedido.numpedido,
          idalmacen: vendedor.idalmacen,
          tipounidad: records[i].tipounidad,
          idunidadmedida: records[i].idunidadmedida,
          idunidadalterna: records[i].idunidadalterna,
          tipofactor: records[i].tipofactor,
          valorfactor: records[i].valorfactor,
          tasa: monedaSub.valormoneda,
        });

        notaedet.push({
          idproducto: records[i].idproducto,
          cantidad: records[i].cantidad,
          punitario: records[i].precio,
          punitariobs: parseFloat(records[i].precio) * parseFloat(monedaSub.valormoneda),
          descuento: "0.00",
          iva: records[i].iva,
          tipounidad: records[i].tipounidad,
          idunidadmedida: records[i].idunidadmedida,
          idunidadalterna: records[i].idunidadalterna,
          tasa: monedaSub.valormoneda,
          codproducto: records[i].codigo,
          costo: records[i].costocalculado,
          utilidad: records[i].utipreciomaxi,
          tipopreciodeta: records[i].tipoprecio,
        });
      }
      setNotaedeta(notaedet);
      setOpeinvc(opeinv);
      setOpeinvdetc(opeinvdet);
      setBody({
        notaentre: pedi,
        notaentredet: pedidet,
        idtipopeinv: 2,
        opeinv: [],
        opeinvdet: [],
      });
      setBody2({
        notaentre: notae,
        notaentredet: notaedet,
        pagos: [],
        pagosdeta: [],
        app: false,
        ncaja: 77,
        fecharev: null,
        fechapag: null,
        nidcaja: null,
        idusu: null,
        motivo: '',
        opinv: opeinv,
        opeinvdet: opeinvdet,
      });

      let msg = "";
      if (operacion === 1) {
        msg = "Esta Seguro de Registrar estos Datos.";
      } else if (operacion === 2) {
        msg = "Esta Seguro de Modificar estos Datos.";
      } else if (operacion === 3) {
        msg = "Esta Seguro de Eliminar estos Datos.";
      }

      if (pedido.status === 4) {
        setMensaje({
          mostrar: true,
          titulo: "Notificacion",
          texto: "El pedido ya fue anulado",
          icono: "error",
        });
      } else {
        setMensajesino({
          mostrar: true,
          titulo: "Confirmación.",
          texto: msg,
          icono: "confirmacion",
        });
      }
    }
  };

  const onBotones = (op) => (e) => {
    e.preventDefault();

    if (op === 3) {
      setMostrarsup(true);
    } else if (op === 5) {
      onChangeValidar();
    } else if (op === 6) {
      seleccionarMonedas();
      seleccionarVendedor(idagente);
      blanquear();
    }

  };

  const selectnumfactu = () => {
    let tabla = "notaentrega";
    let id = "idnotaentrega";
    let idtabla = "idnotaentrega";
    let endpoint = `${op.conexion}/api/inventario/consultacodigos?tabla=${tabla}&idtabla=${idtabla}&id=${id}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.numeroasignado > 0) {
            let to = parseFloat(response.data.numeroasignado) + 1;
            let cerrrou = '000000';
            let paddedNumber = lpad(to.toString(), cerrrou, 7);
            setNumnotaentrega("NE" + paddedNumber);
          } else {
            setNumnotaentrega("NE000001");
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(() => {
        setActivate(false);
      });
  };

  const selectnumPedido = () => {
    let tabla = "pedido";
    let id = "idpedido";
    let idtabla = "idpedido";
    let endpoint = `${op.conexion}/api/inventario/consultacodigos?tabla=${tabla}&idtabla=${idtabla}&id=${id}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.numeroasignado > 0) {
            let to = parseFloat(response.data.numeroasignado) + 1;
            let cerrrou = '000000';
            let paddedNumber = lpad(to.toString(), cerrrou, 7);
            txtNumPedido.current.value = "P" + paddedNumber;
            setIdpedi(to);
          } else {
            txtNumPedido.current.value = "P0000001";
            setIdpedi(0);
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(() => {
        setActivate(false);
      });
  };

  useEffect(() => {
    seleccionarMonedas();
    seleccionarVendedor(idagente);
    const handleKeyDown = (evento) => {
      if (evento.key === 'F12') {
        evento.preventDefault();
        onChangeValidar();
      }
    };

    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  function toggleFullscreen() {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen();
    } else {
      document.exitFullscreen();
    }
  }

  const imprimirDesdeFacturar = async (id) => {
    console.log('🔍 Iniciando impresión desde facturar para ID:', id);

    // 1. Validaciones básicas
    if (!id) {
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto: "No hay ID de factura para imprimir.",
        icono: "error"
      });
      return;
    }

    if (!printerStatus.connected) {
      setMensaje({
        mostrar: true,
        titulo: "Bluetooth Desconectado",
        texto: "Por favor, conecte la impresora Bluetooth antes de continuar.",
        icono: "informacion"
      });
      return;
    }

    // 2. Actualizar estado UI (Mostrando "Imprimiendo...")
    setPrinterStatus(prev => ({
      ...prev,
      printing: true,
      statusMessage: 'Imprimiendo factura...'
    }));

    try {
      // 3. Generar el contenido del ticket (String ESC/POS)
      // Llama a tu función existente que trae los datos de la API
      const ticket = await generateTicketWithTable(id);

      console.log('✅ Ticket generado correctamente. Enviando a impresora...');

      // 4. Codificar el texto a Bytes (Uint8Array)
      const encoder = new TextEncoder();
      const data = encoder.encode(ticket);
      const characteristic = printerStatus.characteristic;

      if (!characteristic) {
        throw new Error('La impresora está conectada pero no se encontró el canal de comunicación (Characteristic). Intente desconectar y conectar de nuevo.');
      }

      // 5. Definir tamaño del paquete (Chunk) según el tipo de impresora detectada
      const chunkSize = printerStatus.printerType === 'mp80' ? 40 :
        printerStatus.printerType === 'jingpu' ? 20 : 10;

      console.log(`📤 Enviando ${data.length} bytes en fragmentos de ${chunkSize} bytes...`);

      // 6. Bucle de envío de datos
      for (let i = 0; i < data.length; i += chunkSize) {
        const chunk = data.slice(i, i + chunkSize);

        try {
          // Intentar enviar sin respuesta (más rápido)
          if (characteristic.properties.writeWithoutResponse) {
            await characteristic.writeValueWithoutResponse(chunk);
          }
          // Si no tiene writeWithoutResponse, intentar con write (con respuesta)
          else if (characteristic.properties.write) {
            await characteristic.writeValue(chunk);
          }
          else {
            throw new Error('La característica de la impresora no permite escribir datos.');
          }
        } catch (chunkError) {
          console.error(`❌ Error enviando fragmento ${i}:`, chunkError);
          // Si falla un fragmento (ej: impresora desconectó aquí), detenemos todo
          throw chunkError;
        }

        // Pequeña pausa entre paquetes para no saturar el buffer de la impresora
        // NOTA: Si la impresora desconecta por timeout, puedes intentar bajar esto a 0
        if (i + chunkSize < data.length) {
          await new Promise(resolve => setTimeout(resolve, 5));
        }
      }

      console.log('✅ Envío de datos finalizado correctamente.');

      // 7. Finalizar estado UI (Éxito)
      setPrinterStatus(prev => ({
        ...prev,
        printing: false,
        statusMessage: 'Listo' // La impresora se mantiene conectada
      }));

      setMensaje({
        mostrar: true,
        titulo: "Impresión Exitosa",
        texto: "El ticket fue enviado a la impresora.",
        icono: "exito"
      });

    } catch (error) {
      console.error('❌ Error en imprimirDesdeFacturar:', error);

      // 8. Finalizar estado UI (Error)
      setPrinterStatus(prev => ({
        ...prev,
        printing: false,
        statusMessage: 'Error al imprimir' // No desconectamos, pero indicamos fallo
      }));

      // Si el error es de conexión (la impresora se desconectó sola), el mensaje lo indicará
      let mensajeError = error.message || "Ocurrió un error al intentar imprimir.";
      if (error.message.includes('disconnected') || error.message.includes('Device')) {
        mensajeError = "La impresora se desconectó inesperadamente. Por favor reconéctela.";
      }

      setMensaje({
        mostrar: true,
        titulo: "Error de Impresión",
        texto: mensajeError,
        icono: "error"
      });
    }
  };
  const BluetoothPrintButtons = () => {
    if (!bluetoothStatus.checked) return null;

    return (
      <div className="row col-md-12 mx-auto mb-3 p-3 border rounded bg-light shadow-sm">

        <div className="col-md-12">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <h5 className="fw-bold text-primary mb-0">
              <i className="fas fa-print me-2"></i>
              Impresión Bluetooth Universal
            </h5>

          </div>

          <div className="row align-items-center mb-2">
            <div className="col-md-5">
              <div className="input-group input-group-sm">
                <span className="input-group-text fw-bold">
                  <i className={`fas fa-circle ${printerStatus.connected ? 'text-success' :
                    printerStatus.scanning ? 'text-warning' :
                      'text-danger'
                    }`}></i>
                </span>
                <input
                  type="text"
                  className={`form-control fw-bold ${printerStatus.connected ? 'text-success' :
                    printerStatus.scanning ? 'text-warning' :
                      'text-danger'
                    }`}
                  value={printerStatus.statusMessage}
                  readOnly
                  title={printerStatus.errorDetails}
                />
              </div>
            </div>

            <div className="col-md-7 d-flex justify-content-end flex-wrap gap-2">
              {!printerStatus.scannedDevice ? (
                <button
                  onClick={scanForBluetoothDevices}
                  disabled={printerStatus.scanning}
                  className={`btn btn-sm ${printerStatus.scanning ? 'btn-warning' : 'btn-info'}`}
                >
                  {printerStatus.scanning ? (
                    <div>
                      <span className="spinner-border spinner-border-sm me-2"></span>
                      Buscando...
                    </div>
                  ) : (
                    <div>
                      <i className="fas fa-search me-2"></i>
                      Buscar Impresora
                    </div>
                  )}
                </button>
              ) : null}

              {printerStatus.scannedDevice && !printerStatus.connected ? (
                <button
                  onClick={connectToPrinter}
                  disabled={printerStatus.scanning}
                  className={`btn btn-sm ${printerStatus.scanning ? 'btn-warning' : 'btn-success'}`}
                >
                  {printerStatus.scanning ? (
                    <div>
                      <span className="spinner-border spinner-border-sm me-2"></span>
                      Conectando...
                    </div>
                  ) : (
                    <div>
                      <i className="fas fa-plug me-2"></i>
                      Conectar
                    </div>
                  )}
                </button>
              ) : null}

              {printerStatus.connected ? (
                <div>


                  {/*   <button
                    onClick={async () => {
                      try {
                        console.log('🔍 Probando generación de ticket...');
                        await generateSimpleTestTicket();
                        console.log('✅ Ticket generado correctamente');
                   

                          await printTestFormat('table');
                      } catch (error) {
                        console.error('❌ Error en prueba:', error);
                      }
                    }} className="btn btn-outline-success"
                    title="Imprimir ticket con tabla"
                  >
                    {printerStatus.printing ? (
                      <div>
                        <span className="spinner-border spinner-border-sm me-2"></span>
                        Imprimiendo...
                      </div>
                    ) : (
                      <div>
                        <i className="fas fa-print me-2"></i>
                        Ticket Prueba
                      </div>
                    )}
                  </button>
 */}

                  <button
                    onClick={disconnectPrinter}
                    className="btn btn-sm btn-danger"
                  >
                    <i className="fas fa-power-off me-2"></i>
                    Desconectar
                  </button>
                </div>
              ) : null}
            </div>
          </div>

          {printerStatus.errorDetails && (
            <div className="alert alert-danger p-2 mt-2 small">
              <i className="fas fa-exclamation-triangle me-2"></i>
              <strong>Error:</strong>
              <div className="text-muted mt-1 small">{printerStatus.errorDetails}</div>
            </div>
          )}


        </div>
      </div>
    );
  };




  return (
    <div style={{ height: "100%", width: "100%" }}>
      <div className="row col-md-12 " style={{ margin: 0 }}>
        <div className="row col-md-12 py-2" style={{ margin: 0 }}>
          <div className="col-md-12 mx-auto py-2  card shadow ">
            <div className="col-md-12 row border-azul mx-auto justify-content-between rounded py-2">
              <div className="col-md-12 border-azul rounded py-2 row mx-auto mb-2 azulGradiant shadow text-light justify-content-between">
                <div className="col-md-4">
                  <h3>{tituloHeader}</h3>
                </div>
                <div className="col-md-3 d-flex justify-content-end">
                  <button
                    className="btn btn-out-line text-white"
                    onClick={toggleFullscreen}
                  >
                    PANTALLA COMPLETA
                  </button>
                </div>
                <div className="col-md-3 d-flex justify-content-end">
                  <a href="/inicio" className="text-light ">
                    <i className="fas fa-times mx-2"></i>
                    <span className="fw-bold">Salir</span>
                  </a>
                </div>
              </div>



              <div
                className="row col-md-12 mx-auto mb-1 p-0 m-0 justify-content-between"
                style={{ fontSizeAdjust: "0.6" }}
              >

                <div className="input-group input-group-sm mb-2 col-pd-283 px-2">
                  <label
                    className="input-group-text fw-bold text-black"
                    id="input-id"
                  >
                    PEDIDO:
                  </label>
                  <input
                    type="text"
                    disabled
                    ref={txtNumPedido}
                    name="numpedido"
                    autoComplete="off"
                    onKeyUp={validarNumPedido}
                    onBlur={validarNumPedido}
                    onChange={(e) =>
                      (e.target.value = e.target.value.toUpperCase())
                    }
                    className="form-control fs-6 text-danger"
                    aria-label="Sizing example input"
                    aria-describedby="input-id"
                  />
                  <button
                    type="button"
                    onClick={() => setCatalogoPedido(true)}
                    className="btn btn-success"
                  >
                    <i className="fas fa-search"></i>
                  </button>
                </div>

                <input type="hidden" ref={txtIdnota} />
                <input type="hidden" ref={txtNunnota} />

                {operacion !== 1 && (
                  <div className="mb-2 col-pd-240">
                    <div className="input-group input-group-sm">
                      <label
                        className="input-group-text fw-bold text-black"
                        id="inputGroup-sizing-sm"
                      >
                        ESTATUS:
                      </label>
                      <select
                        ref={txtStatus}
                        style={{
                          fontWeight: "bold",
                          color:
                            pedido.status === 0
                              ? "#007bff"
                              : pedido.status === 1
                                ? "#28a745"
                                : pedido.status === 4
                                  ? "#dc3545"
                                  : "#000000",
                        }}
                        disabled
                        className="form-select form-select-sm text-uppercase px-1"
                        aria-label=".form-select-sm example"
                      >
                        <option value="0">PENDIENTE</option>
                        <option value="1">PROCESADO</option>
                        <option value="4">ANULADO</option>
                      </select>
                    </div>
                  </div>
                )}

                <div className="col-pd-600 mb-1 mx-auto">
                  <div className="input-group input-group-sm">
                    <label
                      className="input-group-text bg-transparent border-0"
                      id="inputGroup-sizing-sm"
                    >
                      <span className="fw-bold text-black fs-6">VENDEDOR</span>:{" "}
                    </label>
                    <input
                      type="text"
                      ref={txtNombreV}
                      autoComplete="off"
                      disabled
                      name="nombres"
                      value={vendedor.nombre + '-' + vendedor.rif}
                      className="form-control fs-5 bg-transparent border-0"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                    />
                  </div>

                </div>

                <div className="input-group input-group-sm mb-2 col-pd-220 ml-auto px-2">
                  <label
                    className="input-group-text fw-bold text-black"
                    id="inputGroup-sizing-sm"
                  >
                    FECHA:
                  </label>
                  <input
                    autoComplete="off"
                    type="date"
                    disabled={!habilitado}
                    ref={txtFecha}
                    className="form-control fs-6 text-uppercase"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    name="fecha"
                    onKeyUp={handleInputChange}
                    onBlur={handleInputChange}
                  />
                </div>

                <div className="input-group input-group-sm mb-1 col-md-12">
                  <label
                    className="input-group-text"
                    id="inputGroup-sizing-sm"
                  >
                    <span className="fw-bold text-black">CLIENTE</span>:{" "}
                  </label>
                  <select
                    ref={cmbRif}
                    name="cmbrif"
                    style={{ maxWidth: 60 }}
                    disabled={!habilitadoCli}
                    className="form-select form-select-sm col-md-3 text-center text-uppercase"
                    aria-label=".form-select-sm example"
                  >
                    {cmbCedula.map((item, index) => (
                      <option key={index} value={item.value}>
                        {" "}
                        {item.value}{" "}
                      </option>
                    ))}
                  </select>
                  <input
                    ref={txtRif}
                    autoComplete="off"
                    disabled={!habilitadoCli}
                    style={{ maxWidth: 100 }}
                    maxLength={9}
                    type="text"
                    className="form-control col-md-6 fs-6"
                    name="cedula"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    onKeyUp={validarCliente}
                    onBlur={validarCliente}
                  />
                  <button
                    disabled={!habilitadoCli}
                    type="button"
                    onClick={() => {
                      setTipoAgente("cliente");
                      setCatalogoCliente(true);
                    }}
                    className="btn btn-success"
                  >
                    <i className="fas fa-search"></i>
                  </button>
                  <input
                    type="text"
                    ref={txtNombreC}
                    autoComplete="off"
                    disabled
                    name="nombres"
                    className="form-control fs-6"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                  />
                </div>

                <div className="row col-12 m-0 p-0">

                  <div className="mb-2 col-pd-180 px-2 ml-3">
                    <div className="form-check">
                      <input className="form-check-input" ref={txtCredito} onChange={onCheke} type="checkbox" value="" id="flexCheckDefault" />
                      <label className="form-check-label fs-6" for="flexCheckDefault">
                        ¿ES CREDITO?
                      </label>
                    </div>
                  </div>

                  {visibl !== 0 ? <div className="input-group input-group-sm mb-1 col-pd-320 px-1">
                    <label
                      className="input-group-text fw-bold text-black"
                      id="inputGroup-sizing-sm"
                    >
                      FECHA VENCIMIENTO:
                    </label>
                    <input
                      autoComplete="off"
                      type="date"
                      ref={txtFechaVence}
                      className="form-control fs-6 text-uppercase"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      name="fecha"
                      onKeyUp={handleInputChange}
                      onBlur={handleInputChange}
                    />
                  </div> : ''}

                  <div className="input-group input-group-sm mb-1 col-pd-280 ml-auto px-2">
                    <label
                      className="input-group-text fw-bold text-black"
                      id="inputGroup-sizing-sm"
                    >
                      TIPO MONEDA:
                    </label>
                    <select
                      className="form-control form-control-sm px-1 fw-bold text-center"
                      disabled={true}
                      ref={cmbMoneda}
                      onChange={onChangeMoneda}
                    >
                      {combomoneda &&
                        combomoneda.map((item, index) => (
                          <option key={index} value={index}>
                            {" "}
                            {`${item.descripcion} ${item.simbolo} ${formatMoneda(
                              item.valormoneda
                                .toString()
                                .replace(",", "")
                                .replace(".", ","),
                              ",",
                              ".",
                              2
                            )}`}{" "}
                          </option>
                        ))}
                    </select>
                  </div>

                </div>
              </div>

              <div className="row col-md-8 p-0 m-0">
                <div className="col-pd-220 px-0 m-0">
                  <div
                    className="input-group input-group-sm"
                  >
                    <input
                      type="text"
                      disabled={habilitadoProductos}
                      ref={txtIdproducto}
                      placeholder="CODIGO"
                      className="form-control form-control-sm bg-light fs-6 col-pd-110"
                      onChange={(e) =>
                        (e.target.value = e.target.value.toUpperCase())
                      }
                      onKeyUp={validarIdProducto(null)}
                    />
                    <button
                      type="button"
                      disabled={habilitadoProductos}
                      onClick={() => setMostrar(true)}
                      className="btn btn-sm btn-primary"
                    >
                      <i className="fas ">-</i>
                    </button>
                  </div>
                </div>

                <div
                  className="col-md-12 border-azul rounded px-0"
                  style={{ backgroundColor: "#d5e9ff" }}
                >
                  <TblContainer
                    container={{
                      height: 300,
                      width: "100%",
                      overflow: "auto",
                      padding: "2px",
                      fontSizeAdjust: "0.6",
                    }}
                  >
                    <TblHead />
                    <TableBody className="overflow-hidden">
                      {records &&
                        records.map((item, index) => (
                          <TableRow key={index} style={{ padding: "0" }}>
                            <TableCell className="bg-light d-flex align-items-between px-0">
                              <input
                                type="text"
                                style={{
                                  borderBottomRightRadius: 0,
                                  borderTopRightRadius: 0,
                                }}
                                disabled={habilitadoProductos}
                                ref={(el) => (txtId.current[index] = el)}
                                className="form-control form-control-sm bg-light fs-6"
                                defaultValue={item.codigo}
                                onChange={(e) =>
                                (e.target.value =
                                  e.target.value.toUpperCase())
                                }
                                onKeyUp={validarIdProducto(index)}
                                onBlur={validarIdProducto(index)}
                              />
                              {(operacion === 1 || operacion === 2) && (
                                <button
                                  type="button"
                                  style={{
                                    borderBottomLeftRadius: 0,
                                    borderTopLeftRadius: 0,
                                  }}
                                  disabled={habilitadoProductos}
                                  onClick={seleccionarxIndice(index)}
                                  className="btn btn-sm btn-primary"
                                >
                                  <i className="fas ">-</i>
                                </button>
                              )}
                            </TableCell>
                            <TableCell
                              className="align-middle bg-light text-start p-0 pl-2"
                              style={{ width: "150px" }}
                            >
                              {item.nombrecorto}
                            </TableCell>

                            {operacion === 4 ? (
                              ""
                            ) : (
                              <TableCell
                                className="align-middle bg-light text-end p-0 pr-2"
                                style={{ width: "30px" }}
                              >
                                {formatMoneda(
                                  item.cantidadE
                                    .toString()
                                    .replace(",", "")
                                    .replace(".", ","),
                                  ",",
                                  ".",
                                  2
                                )}
                              </TableCell>
                            )}

                            <TableCell className="align-middle bg-light text-center p-0">
                              <input
                                type="text"
                                className="form-control form-control-sm bg-light text-right fs-6 col-pd-90 mx-auto"
                                id="cantidad"
                                disabled={operacion === 1 || operacion === 2 ? false : true}
                                defaultValue={formatMoneda(
                                  item.cantidad
                                    .toString()
                                    .replace(",", "")
                                    .replace(".", ","),
                                  ",",
                                  ".",
                                  2
                                )}
                                ref={(el) => (txtCantidad.current[index] = el)}
                                onFocus={seleccionarCampo}
                                onKeyUp={validarCantidadP(index)}
                                onBlur={validarCantidadP(index)}
                              />
                            </TableCell>
                            <TableCell
                              className="align-middle bg-light p-0"
                              style={{ width: 50 }}
                            >
                              <select
                                className="form-control form-control-sm fs-6"
                                style={{ width: "100%" }}
                                disabled={true}
                                defaultValue={item.tipoprecio}
                                onChange={onChangeTipoPrecio(index)}
                              >
                                {comboprecios.map((item2, x) => (
                                  <option key={x} value={item2.id}>
                                    {" "}
                                    {item2.nombre}{" "}
                                  </option>
                                ))}
                              </select>
                            </TableCell>
                            <TableCell
                              className="align-middle bg-light text-end p-0 pr-2"
                              style={{ width: "50px" }}
                            >
                              {formatMoneda(
                                (item.precio * item.valormoneda)
                                  .toString()
                                  .replace(",", "")
                                  .replace(".", ","),
                                ",",
                                ".",
                                2
                              )}
                            </TableCell>
                            <TableCell
                              className="align-middle bg-light p-0"
                              style={{ width: 50 }}
                            >
                              <select
                                className="form-control form-control-sm fs-6"
                                style={{ width: "100%" }}
                                disabled={habilitadoProductos}
                                onChange={onChangeUnidad(index)}
                              >
                                {item.unidad &&
                                  item.unidad.map((item2, x) => (
                                    <option key={x} value={item2.idunidad}>
                                      {" "}
                                      {item2.descripcion}{" "}
                                    </option>
                                  ))}
                              </select>
                            </TableCell>
                            <TableCell
                              className="align-middle bg-light text-end p-0"
                              style={{ width: "50px" }}
                            >
                              {formatMoneda(
                                (item.precio * item.cantidad * item.valormoneda)
                                  .toString()
                                  .replace(",", "")
                                  .replace(".", ","),
                                ",",
                                ".",
                                2
                              )}
                            </TableCell>
                            <TableCell
                              className="align-middle bg-light text-center p-0"
                              style={{ width: "20px" }}
                            >
                              <button
                                disabled={operacion === 4 || operacion === 3 ? true : false}
                                style={{
                                  visibility:
                                    (operacion === 4 || operacion === 3) &&
                                    "collapse",
                                }}
                                onClick={eliminarProducto(item)}
                                className="btn btn-sm btn-danger"
                              >
                                <i className="fa fa-trash"></i>{" "}
                              </button>
                            </TableCell>
                          </TableRow>
                        ))}
                      <TableRow
                        style={{
                          padding: "0",
                          visibility:
                            (operacion === 4 ||
                              operacion === 0 ||
                              operacion === 3) &&
                            "collapse",
                        }}
                      >
                        <TableCell className="align-middle bg-light text-center p-0 d-flex">
                          <input
                            type="text"
                            disabled={habilitadoProductos}
                            style={{
                              borderBottomRightRadius: 0,
                              borderTopRightRadius: 0,
                            }}
                            className="form-control form-control-sm bg-light text-right"
                            onChange={(e) =>
                              (e.target.value = e.target.value.toUpperCase())
                            }
                            onKeyUp={validarIdProducto(null)}
                            onBlur={validarIdProducto(null)}
                          />
                          <button
                            type="button"
                            disabled={habilitadoProductos}
                            style={{
                              borderBottomLeftRadius: 0,
                              borderTopLeftRadius: 0,
                            }}
                            onClick={seleccionarxIndice(null)}
                            className="btn btn-sm btn-primary"
                          >
                            <i className="fas ">-</i>
                          </button>
                        </TableCell>
                        <TableCell
                          className="align-middle bg-light text-start p-0 pl-2"
                          style={{ width: "50px" }}
                        ></TableCell>

                        {operacion === 4 ? (
                          ""
                        ) : (
                          <TableCell
                            className="align-middle bg-light text-end p-0 pr-2"
                            style={{ width: "30px" }}
                          ></TableCell>
                        )}

                        <TableCell
                          className="align-middle bg-light text-center p-0"
                          style={{ width: "20px" }}
                        ></TableCell>
                        <TableCell
                          className="align-middle bg-light p-0"
                          style={{ width: 50 }}
                        ></TableCell>
                        <TableCell
                          className="align-middle bg-light text-end p-0 pr-2"
                          style={{ width: "50px" }}
                        ></TableCell>
                        <TableCell
                          className="align-middle bg-light p-0"
                          style={{ width: 50 }}
                        ></TableCell>
                        <TableCell
                          className="align-middle bg-light text-end p-0"
                          style={{ width: "50px" }}
                        ></TableCell>
                        <TableCell
                          className="align-middle bg-light text-center p-0"
                          style={{ width: "20px" }}
                        ></TableCell>
                      </TableRow>
                    </TableBody>
                  </TblContainer>

                  <div
                    className="border-table rounded p-2 shadow col-pd-500"
                    style={{
                      backgroundColor: "#dbeeff",
                      borderTop: "none",
                      fontSizeAdjust: "0.6",
                    }}
                  >
                    <div className="input-group input-group-sm  col-md-12">
                      <label
                        className="input-group-text bg-transparent border-0"
                        style={{ fontSize: 14 }}
                        id="inputGroup-sizing-sm"
                      >
                        SUBTOTAL: {monedaCambio.simbolo}
                      </label>

                      <input
                        type="text"
                        disabled
                        ref={txtSubTotal}
                        value={formatMoneda(
                          (totales.subtotal * monedaCambio.valormoneda)
                            .toString()
                            .replace(",", "")
                            .replace(".", ","),
                          ",",
                          ".",
                          2
                        )}
                        className="form-control bg-transparent fw-bold text-right rounded border-0 fs-5"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                      />
                    </div>
                    <div
                      className="input-group input-group-sm col-md-12"
                      style={{ fontSizeAdjust: "0.6" }}
                    >
                      <label
                        className="input-group-text bg-transparent border-0"
                        id="inputGroup-sizing-sm"
                        style={{ fontSize: 14 }}
                      >
                        EXENTO {monedaCambio.simbolo}:
                      </label>

                      <input
                        type="text"
                        disabled
                        ref={txtExentoTotal}
                        value={formatMoneda(
                          (totales.exento * monedaCambio.valormoneda)
                            .toString()
                            .replace(",", "")
                            .replace(".", ","),
                          ",",
                          ".",
                          2
                        )}
                        className="form-control bg-transparent text-right fw-bold rounded border-0 fs-5"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                      />
                    </div>
                    <div className="input-group input-group-sm  col-md-12">
                      <label
                        className="input-group-text bg-transparent border-0"
                        style={{ fontSize: 14 }}
                        id="inputGroup-sizing-sm"
                      >
                        DESCUENTO: {monedaCambio.simbolo}
                      </label>

                      <input
                        type="text"
                        disabled
                        ref={txtDescuento}
                        value={formatMoneda(
                          (totales.descuento * monedaCambio.valormoneda)
                            .toString()
                            .replace(",", "")
                            .replace(".", ","),
                          ",",
                          ".",
                          2
                        )}
                        className="form-control bg-transparent fw-bold text-right rounded border-0 fs-5"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                      />
                    </div>
                    <div className="input-group input-group-sm  col-md-12">
                      <label
                        className="input-group-text bg-transparent border-0"
                        style={{ fontSize: 14 }}
                        id="inputGroup-sizing-sm"
                      >
                        IVA Sobre(
                        {formatMoneda(
                          totales.iva
                            .toString()
                            .replace(",", "")
                            .replace(".", ","),
                          ",",
                          ".",
                          2
                        )}
                        %) {monedaCambio.simbolo}:{" "}
                        {formatMoneda(
                          (totales.sujeto * monedaCambio.valormoneda)
                            .toString()
                            .replace(",", "")
                            .replace(".", ","),
                          ",",
                          ".",
                          2
                        )}
                      </label>

                      <input
                        type="text"
                        disabled
                        ref={txtTotIva}
                        value={formatMoneda(
                          (totales.totaliva * monedaCambio.valormoneda)
                            .toString()
                            .replace(",", "")
                            .replace(".", ","),
                          ",",
                          ".",
                          2
                        )}
                        className="form-control bg-transparent text-right fw-bold rounded border-0 fs-5"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                      />
                    </div>
                    <div className="input-group input-group-sm  col-md-12">
                      <label
                        className="input-group-text bg-transparent border-0"
                        style={{ fontSize: 14 }}
                        id="inputGroup-sizing-sm"
                      >
                        TOTAL: {monedaCambio.simbolo}
                      </label>

                      <input
                        type="text"
                        disabled
                        ref={txtTotal}
                        value={formatMoneda(
                          (totales.total * monedaCambio.valormoneda)
                            .toString()
                            .replace(",", "")
                            .replace(".", ","),
                          ",",
                          ".",
                          2
                        )}
                        className="form-control bg-transparent text-right fw-bold rounded border-0 fs-5"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                      />
                    </div>
                    <div className="input-group input-group-sm  col-md-12">
                      <label
                        className="input-group-text bg-transparent border-0"
                        style={{ fontSize: 14 }}
                        id="inputGroup-sizing-sm"
                      >
                        TOTAL BS:
                      </label>

                      <input
                        type="text"
                        disabled
                        ref={txtTotalBs}
                        value={formatMoneda(
                          (totales.total * monedaSub.valormoneda)
                            .toString()
                            .replace(",", "")
                            .replace(".", ","),
                          ",",
                          ".",
                          2
                        )}
                        className="form-control bg-transparent text-right fw-bold rounded border-0 fs-5"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                      />
                    </div>
                  </div>
                  {/* <img src="imagenes/logo.ico" className="img-fluid" /> */}
                </div>
              </div>

              <div className="col-md-4 mx-auto ocultaproductos">
                <div className="row card col-md-12 mx-auto p-1 m-0">
                  <div className="col-md-12 row mx-auto">
                    <div
                      className="col-md-12 row mx-auto azulGradiant rounded py-2"
                      style={{ verticalAlign: "middle" }}
                    >
                      <div className="input-group input-group-sm mb-2 col-md-4 my-auto">
                        <input
                          autoComplete="off"
                          onChange={handleSearch}
                          type="text"
                          placeholder="BUSCAR"
                          className="form-control rounded-pill"
                          aria-label="Sizing example input"
                          aria-describedby="inputGroup-sizing-sm"
                        />
                      </div>
                      <h4 className="col-md-6 text-center mx-auto text-light fw-bold">
                        LISTA DE PRODUCTOS
                      </h4>
                    </div>
                    <div
                      className="row col-md-12 mx-auto overflow-scroll rounded px-0 py-1"
                      style={{
                        height: "500px",
                        backgroundColor: "rgb(230, 238, 249)",
                      }}
                    >
                      {listaProductos &&
                        listaProductos.map((item, index) => (
                          <button
                            key={index}
                            onClick={() => agregarProducto(item)}
                            disabled={habilitadoProductos}
                            className="btn zoom hover-overlay col-md-2 bg-gradient p-0 m-0"
                            style={{ minHeight: "60px", maxHeight: "60px" }}
                          >
                            <img
                              className="img-fluid h-100 w-100 "
                              style={{ objectFit: "contain" }}
                              src={`${op.conexion}/imagen?img=${organizacion}/productos/${item.imagen}`}
                            />
                            <div className="mask rounded p-2">
                              <div
                                className="col-md-12 fixed-bottom py-1 border-top  bg-light"
                                style={{ verticalAlign: "middle" }}
                              >
                                <span
                                  className="text-center"
                                  style={{
                                    fontSize: "6px",
                                    color: "rgb(3, 18, 47)",
                                  }}
                                >
                                  {item.nombrecorto.substring(0, 20)}
                                </span>
                              </div>
                            </div>
                          </button>
                        ))}
                    </div>
                  </div>
                </div>
              </div>

              <div className="row col-md-12 mx-auto d-flex justify-content-between  align-items-end mt-3">
                <div className="form-check form-switch my-auto">
                  <input
                    className="form-check-input my-auto"
                    type="checkbox"
                    role="switch"
                    id="switchCheckDefault"
                    checked={bluetoothStatus.checked}
                    onChange={handleBluetoothChange}
                  />
                  <label className={`fw-bold form-check-label ml-3 my-auto ${bluetoothStatus.checked ? 'text-success' : 'text-danger'}`} htmlFor="switchCheckDefault">
                    {bluetoothStatus.checked ? 'Bluetooth Activo' : 'Bluetooth Inactivo'}
                  </label>


                </div>
                <div className="col-pd-650 row m-0 ml-auto">
                  {operacion === 4 && actimprime === 1 ? (
                    <button
                      onClick={imprimirPedido}
                      disabled={operacion === 4 ? false : true}
                      className="btn btn-sm col ml-1 btn-primary rounded-pill"
                      title="Imprimir Nota de Entrega"
                    >
                      <i className="fa fa-print"> Imprimir</i>
                    </button>
                  ) : (
                    <dvi className="col-pd-110"></dvi>
                  )}

                  <button
                    disabled={habilitadoBot}
                    ref={btnEditar}
                    onClick={onBotones(3)}
                    className="btn btn-sm ml-1 col btn-warning rounded-pill"
                    title="Reversar Pago"
                  >
                    <i className="fas fa-undo"> Reversar Pago</i>{" "}
                  </button>
                  <button
                    ref={btnAcepta}
                    disabled={operacion === 4 ? true : habilitadoBot}
                    onClick={onBotones(5)}
                    className="btn btn-sm col ml-1 rounded-pill btn-success"
                  >
                    <i className="fas fa-check-circle"> Aceptar</i>
                  </button>
                  <button
                    ref={btnCancela}
                    disabled={habilitadoBot}
                    onClick={onBotones(6)}
                    className="btn btn-danger col ml-1 btn-sm rounded-pill"
                  >
                    <i className="fas fa-window-close"> Cancelar</i>
                  </button>
                </div>
              </div>
              <BluetoothPrintButtons />
            </div>
          </div>
        </div>
      </div>
      {/*  */}

      <CatalogoProductoExistencia
        show={mostrar}
        onHideCancelar={() => {
          setMostrar(false);
        }}
        onHideAceptaCatalogo={agregarProducto}
        idalmacen={vendedor.idalmacen}
      />
      <ModalSupervisor
        show={mostratsup}
        ope={3}
        onHideCancelar={() => setMostrarsup(false)}
      />
      <CatalogoCliente
        show={catalogoCliente}
        nomid={tipoAgente}
        onHideCancelar={() => setCatalogoCliente(false)}
        onHideAceptaCatalogo={onCatalogoCliente}
      />
      <CatalogoPedido
        show={catalogoPedido}
        nomid="pedido"
        onHideCancelar={() => setCatalogoPedido(false)}
        onHideAceptaCatalogo={oncatalogoPedidoEntrega}
        condicion="true and status = 0"
      />
      <RegistrarPago
        show={mostrar1}
        onRenderizar={blanquear}
        ope={numnotaentregae > 0 ? 2 : 1}
        notentraga={notaen}
        notaentregadeta={notaedeta}
        opinvc={opeinvc}
        opeinvdetc={opeinvdetc}
        idvendedor={vendedor.idvendedor}
        idclient={cliente.idcliente}
        numfactu={numnotaentrega}
        tipo={"notaentrega"}
        montoiva={totales.totaliva}
        monto={totales.total}
        onHideCancelar={() => {
          setMostrar1(false);
        }}
        ticketBluetooth={imprimirDesdeFacturar}
      />
      <Dimmer active={activate} inverted>
        <Loader inverted>cargando...</Loader>
      </Dimmer>
      <Mensaje
        mensaje={mensaje}
        onHide={() =>
          mensaje.titulo === "Exito."
            ? blanquear()
            : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
    </div>
  );
};
export default TablaPosVenta;


// WEBPACK FOOTER //
// ./src/components/ventas/tablaPostVenta.js